import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Const } from '../../../../static/const';
import { HttpClient } from '@angular/common/http';

// Replace this with your real mock JSON data
const MOCK_JSON_WITHOUTGEO = {
  data: [
    {
      'claim__vr.related_projects__c':
        'Cancelled_Test CR0385 2\nTest iRA\nCancel test\nTest12340',
      document_id: '5641',
      document_link:
        'https://sb-unilever-claims.veevavault.com/ui/#doc_info/5641/1/0',
      related_claims: [
        {
          claim_name: 'CLM-000050',
          claim_statement: 'Tese 2',
        },
        {
          claim_name: 'CLM-000023',
          claim_statement: 'Vim2',
        },
        {
          claim_name: 'CLM-000026',
          claim_statement:
            'Kills 99% germs\nKills 99% germs\nKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germs\nKills 99% germs\nKills 99% germs\nKills 99% germs\nKills 99% germsKills 99% germs.',
        },
        {
          claim_name: 'CLM-000034',
          claim_statement: 'Kills 99% germs',
        },
        {
          claim_name: 'CLM-000032',
          claim_statement: 'Tese 3',
        },
        {
          claim_name: 'CLM-000065',
          claim_statement: 'Test Back Translator',
        },
        {
          claim_name: 'CLM-000555',
          claim_statement: 'Test Text 2024 Validation Rule',
        },
        {
          claim_name: 'CLM-000006',
          claim_statement: 'stainlifters Testing 2',
        },
        {
          claim_name: 'CLM-000705',
          claim_statement: 'soft and shiny',
        },
        {
          claim_name: 'CLM-000714',
          claim_statement: 'Vim2',
        },
        {
          claim_name: 'CLM-000732',
          claim_statement:
            'Kills 99% germs\nKills 99% germs\nKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germs\nKills 99% germs\nKills 99% germs\nKills 99% germs\nKills 99% germsKills 99% germs.',
        },
        {
          claim_name: 'CLM-000724',
          claim_statement: 'Kills 99% germs',
        },
        {
          claim_name: 'CLM-000730',
          claim_statement: 'Test Back Translator',
        },
        {
          claim_name: 'CLM-000740',
          claim_statement:
            'Kills 99% germs\nKills 99% germs\nKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germs\nKills 99% germs\nKills 99% germs\nKills 99% germs\nKills 99% germsKills 99% germs.',
        },
        {
          claim_name: 'CLM-000741',
          claim_statement: 'Kills 99% germs',
        },
        {
          claim_name: 'CLM-000749',
          claim_statement: 'Test Back Translator',
        },
        {
          claim_name: 'CLM-000832',
          claim_statement: 'Kills 99% germs',
        },
        {
          claim_name: 'CLM-000798',
          claim_statement:
            'a low suds formula that removes stains without generating foam excess and without soaking',
        },
        {
          claim_name: 'CLM-000992',
          claim_statement: 'Kills 99% germs',
        },
        {
          claim_name: 'CLM-001157',
          claim_statement: 'Test',
        },
        {
          claim_name: 'CLM-000822',
          claim_statement: 'REMOVES TOUGH STAINS AND 99.9% GERMS IN 1 WASH',
        },
        {
          claim_name: 'CLM-001403',
          claim_statement: 'Test Statement 1',
        },
        {
          claim_name: 'CLM-001493',
          claim_statement: 'Free of Perfumes',
        },
        {
          claim_name: 'CLM-001820',
          claim_statement:
            'Kills 99% germs\nKills 99% germs\nKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germs\nKills 99% germs\nKills 99% germs\nKills 99% germs\nKills 99% germsKills 99% germs.',
        },
        {
          claim_name: 'CLM-001987',
          claim_statement:
            'Kills 99% germs\nKills 99% germs\nKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germs\nKills 99% germs\nKills 99% germs\nKills 99% germs\nKills 99% germsKills 99% germs.',
        },
        {
          claim_name: 'CLM-002508',
          claim_statement:
            'Kills 99% germs\nKills 99% germs\nKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germs\nKills 99% germs\nKills 99% germs\nKills 99% germs\nKills 99% germsKills 99% germs.',
        },
        {
          claim_name: 'CLM-003051',
          claim_statement: 'Test Back Translator',
        },
        {
          claim_name: 'CLM-003075',
          claim_statement: 'Test Back Translator',
        },
        {
          claim_name: 'CLM-001824',
          claim_statement: 'Kills 99% germs',
        },
        {
          claim_name: 'CLM-000624',
          claim_statement: 'This is the Test 100',
        },
        {
          claim_name: 'CLM-002924',
          claim_statement:
            'Kills 99% germs\nKills 99% germs\nKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germs\nKills 99% germs\nKills 99% germs\nKills 99% germs\nKills 99% germsKills 99% germs.',
        },
        {
          claim_name: 'CLM-002925',
          claim_statement: 'Kills 99% germs',
        },
        {
          claim_name: 'CLM-002935',
          claim_statement: 'Test Back Translator',
        },
        {
          claim_name: 'CLM-003106',
          claim_statement: 'Test Back Translator',
        },
        {
          claim_name: 'CLM-003127',
          claim_statement:
            'Kills 99% germs\nKills 99% germs\nKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germs\nKills 99% germs\nKills 99% germs\nKills 99% germs\nKills 99% germsKills 99% germs.',
        },
        {
          claim_name: 'CLM-003128',
          claim_statement: 'Kills 99% germs',
        },
        {
          claim_name: 'CLM-003138',
          claim_statement: 'Test Back Translator',
        },
        {
          claim_name: 'CLM-003160',
          claim_statement:
            'Kills 99% germs\nKills 99% germs\nKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germs\nKills 99% germs\nKills 99% germs\nKills 99% germs\nKills 99% germsKills 99% germs.',
        },
        {
          claim_name: 'CLM-003161',
          claim_statement: 'Kills 99% germs',
        },
        {
          claim_name: 'CLM-003171',
          claim_statement: 'Test Back Translator',
        },
        {
          claim_name: 'CLM-003189',
          claim_statement: 'Original',
        },
        {
          claim_name: 'CLM-001499',
          claim_statement: 'Original',
        },
        {
          claim_name: 'CLM-003279',
          claim_statement: 'Soothes & Repairs',
        },
        {
          claim_name: 'CLM-003377',
          claim_statement: 'Vim2',
        },
        {
          claim_name: 'CLM-003326',
          claim_statement: 'Test Back Translator',
        },
        {
          claim_name: 'CLM-003487',
          claim_statement: 'Vim2',
        },
        {
          claim_name: 'CLM-003413',
          claim_statement: 'Test Back Translator',
        },
        {
          claim_name: 'CLM-003528',
          claim_statement: 'Vim2',
        },
        {
          claim_name: 'CLM-003543',
          claim_statement: 'Test Back Translator',
        },
        {
          claim_name: 'CLM-003491',
          claim_statement: '100% unbeatable* streak-free shine',
        },
        {
          claim_name: 'CLM-000059',
          claim_statement: 'Tese 1',
        },
        {
          claim_name: 'CLM-000003',
          claim_statement: 'stainlifters test',
        },
        {
          claim_name: 'CLM-002181',
          claim_statement:
            '*Vs. UK market leader in bathroom sprays ** Tested on most common kitchen surfaces',
        },
        {
          claim_name: 'CLM-002439',
          claim_statement:
            'free from phosphate, optical brightener and alkaline ingredients',
        },
        {
          claim_name: 'CLM-004210',
          claim_statement:
            'free from phosphate, optical brightener and alkaline ingredients',
        },
        {
          claim_name: 'CLM-004344',
          claim_statement: 'Vim2',
        },
        {
          claim_name: 'CLM-004413',
          claim_statement: 'Test Back Translator',
        },
        {
          claim_name: 'CLM-004700',
          claim_statement: 'Vim2',
        },
        {
          claim_name: 'CLM-004872',
          claim_statement: 'Dove',
        },
        {
          claim_name: 'CLM-004871',
          claim_statement: '2 HO HO 13 0 2.1',
        },
        {
          claim_name: 'CLM-004732',
          claim_statement: 'PLAY',
        },
      ],
      related_products: [
        'Surf Excel Matic Std Liquid test1 To Copy 3',
        'TRESemme Conditioner TRESemmé Silky & Smooth Conditioner',
        'Arisco Universal Seasoning Carne',
        'Arisco Vinegar To Variant 2',
        'TRESemme Shampoo Ultra To Copy Test 2',
        'TRESemme Shampoo TRESemmé Rich Moisture Shampoo',
        'TRESemme Shampoo TRESemme Rich Moisture Shampoo order Variant Create 1',
        'TRESemme Shampoo Daily moisture',
        'Vaseline Body Lotion Intensive Care / Soothing Hydration',
        'TRESemme Shampoo TRESemmé Silky & Smooth Shampoo 2',
        'Arisco Vinegar To Variant 3 Variant 1',
        'Dove Antiperspirant Aerosol Spray Advanced Care Name Update 3',
        'Calve Vinegar Test Var state change',
        "Pond's Men Face Wash Foam Brightening & Anti Dark Spot",
        'Dove Antiperspirant Aerosol Spray Advanced Care Name Update 3 TRESemmé Color Revitalise Shampoo',
        'Comfort Rinse Conditioner FIBER PROTECT',
        'Surf Excel Matic Std Liquid Test',
        'TRESemme Conditioner smooth TRESemmé Rich Moisture Conditioner',
        'Dove Skin Cleansing Bar CR411 01',
        'Dove Deo Aero AP Spray',
        'Cif Abrasive Cream ORIGINAL',
        "Ben & Jerry's Ice Cream Pint flavour",
        'Brilhante Washing Powder Brilhante Limpeza Total Pó',
        'Arisco Vinegar To Copy Variant 6 To COpy Job',
        'Dove Antiperspirant Aerosol Spray Advanced Care Name Update 3 TRESemmé Keratin Repair Shampoo',
        'Brilhante Washing Powder Brilhante Higiene Total Liquido',
        'Dove Antiperspirant Aerosol Spray Advanced Care Original',
        'Dove Antiperspirant Aerosol Spray Advanced Care Name Update 3 Awaken',
        'Omo Concentrated Washing Capsules Test',
        'Dove Deo Aero AP Spray dgdfg',
        'Dove Antiperspirant Aerosol Spray Advanced Care Name Update 3 TRESemmé Keratin Color Shampoo',
        'Omo Liquid Ultra Power',
        'Dove Deo Aero AP Advanced Care To Copy test 3',
        'Dove Shampoo Daily Moisture',
        'TRESemme Shampoo TRESemme Rich Moisture Shampoo order',
      ],
      related_projects: [
        'Cancelled_Test CR0385 2\nTest iRA\nCancel test\nTest12340',
      ],
      'substantiation__vr.description__v': 'Test unclassified',
      'substantiation__vr.name__v': 'SUB-000001',
    },
    {
      'claim__vr.related_projects__c': 'Cancelled_Cancelled_Cancelled_test',
      document_id: '8908',
      document_link:
        'https://sb-unilever-claims.veevavault.com/ui/#doc_info/8908/0/1',
      related_claims: [
        {
          claim_name: 'CLM-000002',
          claim_statement: 'stainlifters test',
        },
        {
          claim_name: 'CLM-000026',
          claim_statement:
            'Kills 99% germs\nKills 99% germs\nKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germs\nKills 99% germs\nKills 99% germs\nKills 99% germs\nKills 99% germsKills 99% germs.',
        },
        {
          claim_name: 'CLM-000034',
          claim_statement: 'Kills 99% germs',
        },
        {
          claim_name: 'CLM-000032',
          claim_statement: 'Tese 3',
        },
        {
          claim_name: 'CLM-000031',
          claim_statement: 'Tese 2',
        },
        {
          claim_name: 'CLM-000555',
          claim_statement: 'Test Text 2024 Validation Rule',
        },
        {
          claim_name: 'CLM-000565',
          claim_statement: 'stainlifters Testing 2',
        },
        {
          claim_name: 'CLM-000732',
          claim_statement:
            'Kills 99% germs\nKills 99% germs\nKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germs\nKills 99% germs\nKills 99% germs\nKills 99% germs\nKills 99% germsKills 99% germs.',
        },
        {
          claim_name: 'CLM-000724',
          claim_statement: 'Kills 99% germs',
        },
        {
          claim_name: 'CLM-000740',
          claim_statement:
            'Kills 99% germs\nKills 99% germs\nKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germs\nKills 99% germs\nKills 99% germs\nKills 99% germs\nKills 99% germsKills 99% germs.',
        },
        {
          claim_name: 'CLM-000741',
          claim_statement: 'Kills 99% germs',
        },
        {
          claim_name: 'CLM-000832',
          claim_statement: 'Kills 99% germs',
        },
        {
          claim_name: 'CLM-000894',
          claim_statement: 'stainlifters test',
        },
        {
          claim_name: 'CLM-000798',
          claim_statement:
            'a low suds formula that removes stains without generating foam excess and without soaking',
        },
        {
          claim_name: 'CLM-000912',
          claim_statement:
            'New all® fresh & sensitive™ has a clean  fresh hypoallergenic scent  so its gentle on skin  but tough on stains. Now you can have it all.',
        },
        {
          claim_name: 'CLM-001016',
          claim_statement: 'Eliminates visible and invisible dirt',
        },
        {
          claim_name: 'CLM-000893',
          claim_statement: 'stainlifters test',
        },
        {
          claim_name: 'CLM-000822',
          claim_statement: 'REMOVES TOUGH STAINS AND 99.9% GERMS IN 1 WASH',
        },
        {
          claim_name: 'CLM-001403',
          claim_statement: 'Test Statement 1',
        },
        {
          claim_name: 'CLM-001493',
          claim_statement: 'Free of Perfumes',
        },
        {
          claim_name: 'CLM-001820',
          claim_statement:
            'Kills 99% germs\nKills 99% germs\nKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germs\nKills 99% germs\nKills 99% germs\nKills 99% germs\nKills 99% germsKills 99% germs.',
        },
        {
          claim_name: 'CLM-001821',
          claim_statement: 'stainlifters test',
        },
        {
          claim_name: 'CLM-001987',
          claim_statement:
            'Kills 99% germs\nKills 99% germs\nKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germs\nKills 99% germs\nKills 99% germs\nKills 99% germs\nKills 99% germsKills 99% germs.',
        },
        {
          claim_name: 'CLM-001999',
          claim_statement: 'stainlifters test',
        },
        {
          claim_name: 'CLM-002079',
          claim_statement: 'stainlifters test',
        },
        {
          claim_name: 'CLM-002098',
          claim_statement: 'stainlifters test',
        },
        {
          claim_name: 'CLM-002176',
          claim_statement: 'stainlifters test',
        },
        {
          claim_name: 'CLM-002258',
          claim_statement: 'stainlifters test',
        },
        {
          claim_name: 'CLM-002508',
          claim_statement:
            'Kills 99% germs\nKills 99% germs\nKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germs\nKills 99% germs\nKills 99% germs\nKills 99% germs\nKills 99% germsKills 99% germs.',
        },
        {
          claim_name: 'CLM-002520',
          claim_statement: 'stainlifters test',
        },
        {
          claim_name: 'CLM-003055',
          claim_statement: 'Eliminates visible and invisible dirt',
        },
        {
          claim_name: 'CLM-003086',
          claim_statement: 'Eliminates visible and invisible dirt',
        },
        {
          claim_name: 'CLM-001824',
          claim_statement: 'Kills 99% germs',
        },
        {
          claim_name: 'CLM-000621',
          claim_statement: 'Test Text 2024 Validation Rule',
        },
        {
          claim_name: 'CLM-002924',
          claim_statement:
            'Kills 99% germs\nKills 99% germs\nKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germs\nKills 99% germs\nKills 99% germs\nKills 99% germs\nKills 99% germsKills 99% germs.',
        },
        {
          claim_name: 'CLM-002925',
          claim_statement: 'Kills 99% germs',
        },
        {
          claim_name: 'CLM-002946',
          claim_statement: 'Eliminates visible and invisible dirt',
        },
        {
          claim_name: 'CLM-003116',
          claim_statement: 'Eliminates visible and invisible dirt',
        },
        {
          claim_name: 'CLM-003127',
          claim_statement:
            'Kills 99% germs\nKills 99% germs\nKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germs\nKills 99% germs\nKills 99% germs\nKills 99% germs\nKills 99% germsKills 99% germs.',
        },
        {
          claim_name: 'CLM-003128',
          claim_statement: 'Kills 99% germs',
        },
        {
          claim_name: 'CLM-003149',
          claim_statement: 'Eliminates visible and invisible dirt',
        },
        {
          claim_name: 'CLM-003160',
          claim_statement:
            'Kills 99% germs\nKills 99% germs\nKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germs\nKills 99% germs\nKills 99% germs\nKills 99% germs\nKills 99% germsKills 99% germs.',
        },
        {
          claim_name: 'CLM-003161',
          claim_statement: 'Kills 99% germs',
        },
        {
          claim_name: 'CLM-003182',
          claim_statement: 'Eliminates visible and invisible dirt',
        },
        {
          claim_name: 'CLM-003397',
          claim_statement: 'Eliminates visible and invisible dirt',
        },
        {
          claim_name: 'CLM-003459',
          claim_statement: 'Eliminates visible and invisible dirt',
        },
        {
          claim_name: 'CLM-003597',
          claim_statement: 'Eliminates visible and invisible dirt',
        },
        {
          claim_name: 'CLM-003491',
          claim_statement: '100% unbeatable* streak-free shine',
        },
        {
          claim_name: 'CLM-000003',
          claim_statement: 'stainlifters test',
        },
        {
          claim_name: 'CLM-003971',
          claim_statement: 'stainlifters test',
        },
        {
          claim_name: 'CLM-002181',
          claim_statement:
            '*Vs. UK market leader in bathroom sprays ** Tested on most common kitchen surfaces',
        },
        {
          claim_name: 'CLM-004104',
          claim_statement: 'stainlifters test',
        },
        {
          claim_name: 'CLM-004181',
          claim_statement: 'stainlifters test',
        },
        {
          claim_name: 'CLM-002439',
          claim_statement:
            'free from phosphate, optical brightener and alkaline ingredients',
        },
        {
          claim_name: 'CLM-004210',
          claim_statement:
            'free from phosphate, optical brightener and alkaline ingredients',
        },
        {
          claim_name: 'CLM-004376',
          claim_statement: 'Eliminates visible and invisible dirt',
        },
        {
          claim_name: 'CLM-004871',
          claim_statement: '2 HO HO 13 0 2.1',
        },
      ],
      related_products: [
        'Surf Excel Matic Std Liquid test1 To Copy 3',
        'TRESemme Conditioner TRESemmé Silky & Smooth Conditioner',
        'Arisco Universal Seasoning Carne',
        'Arisco Vinegar To Copy Variant 4',
        'Arisco Vinegar To Variant 2',
        'Arisco Vinegar To Copy Variant 6',
        'TRESemme Shampoo TRESemmé Rich Moisture Shampoo',
        'Arisco Vinegar 2025_2',
        'TRESemme Shampoo TRESemme Rich Moisture Shampoo order Variant Create 1',
        'TRESemme Shampoo Daily moisture',
        'TRESemme Shampoo TRESemme Rich Moisture Shampoo order To Copy Demo 2.',
        'TRESemme Shampoo TRESemmé Silky & Smooth Shampoo 2',
        'Vaseline Body Lotion Intensive Care / Soothing Hydration',
        'Arisco Vinegar To Variant 3 Variant 1',
        'Dove Antiperspirant Aerosol Spray Advanced Care Name Update 3 TRESemmé Color Revitalise Shampoo',
        'Comfort Rinse Conditioner FIBER PROTECT',
        'Surf Excel Matic Std Liquid Test',
        'Dove Deo Aero AP Spray',
        'Cif Abrasive Cream ORIGINAL',
        "Ben & Jerry's Ice Cream Pint flavour",
        'Brilhante Washing Powder Brilhante Limpeza Total Pó',
        'TRESemme Shampoo TRESemme Rich Moisture Shampoo order To Copy Demo 1',
        'Arisco Vinegar To Copy Variant 6 To COpy Job',
        'Dove Antiperspirant Aerosol Spray Advanced Care Name Update 3 TRESemmé Keratin Repair Shampoo',
        'Dove Antiperspirant Aerosol Spray Advanced Care Name Update 3 Awaken',
        'Omo Concentrated Washing Capsules Test',
        'Dove Deo Aero AP Spray dgdfg',
        'Brilhante Tira Manchas Sem Cloro Utile Fresh Liquid',
        'Dove Antiperspirant Aerosol Spray Advanced Care Name Update 3 TRESemmé Keratin Color Shampoo',
        'Omo Liquid Ultra Power',
        'Dove Deo Aero AP Advanced Care To Copy test 3',
        'Dove Shampoo Daily Moisture',
        'TRESemme Shampoo TRESemme Rich Moisture Shampoo order',
        'TRESemme Shampoo TRESemme Rich Moisture Shampoo order To Variant 3',
      ],
      related_projects: ['Cancelled_Cancelled_Cancelled_test'],
      'substantiation__vr.description__v': 'Test CR0403',
      'substantiation__vr.name__v': 'SUB-000002',
    },
    {
      'claim__vr.related_projects__c': 'Cancelled_Cancelled_Cancelled_test',
      document_id: '7904',
      document_link:
        'https://sb-unilever-claims.veevavault.com/ui/#doc_info/7904/0/1',
      related_claims: [
        {
          claim_name: 'CLM-000034',
          claim_statement: 'Kills 99% germs',
        },
        {
          claim_name: 'CLM-000032',
          claim_statement: 'Tese 3',
        },
        {
          claim_name: 'CLM-000031',
          claim_statement: 'Tese 2',
        },
        {
          claim_name: 'CLM-000060',
          claim_statement: 'Smooth and Silky',
        },
        {
          claim_name: 'CLM-000555',
          claim_statement: 'Test Text 2024 Validation Rule',
        },
        {
          claim_name: 'CLM-000566',
          claim_statement: 'Test Text 2024 Validation Rule',
        },
        {
          claim_name: 'CLM-000047',
          claim_statement: 'This is good product',
        },
        {
          claim_name: 'CLM-000724',
          claim_statement: 'Kills 99% germs',
        },
        {
          claim_name: 'CLM-000741',
          claim_statement: 'Kills 99% germs',
        },
        {
          claim_name: 'CLM-000778',
          claim_statement: 'Smooth and Silky',
        },
        {
          claim_name: 'CLM-000053',
          claim_statement: 'Freanch Statement',
        },
        {
          claim_name: 'CLM-000002',
          claim_statement: 'stainlifters test',
        },
        {
          claim_name: 'CLM-000798',
          claim_statement:
            'a low suds formula that removes stains without generating foam excess and without soaking',
        },
        {
          claim_name: 'CLM-000912',
          claim_statement:
            'New all® fresh & sensitive™ has a clean  fresh hypoallergenic scent  so its gentle on skin  but tough on stains. Now you can have it all.',
        },
        {
          claim_name: 'CLM-001016',
          claim_statement: 'Eliminates visible and invisible dirt',
        },
        {
          claim_name: 'CLM-000893',
          claim_statement: 'stainlifters test',
        },
        {
          claim_name: 'CLM-000915',
          claim_statement: 'Faster Stain Removal',
        },
        {
          claim_name: 'CLM-000822',
          claim_statement: 'REMOVES TOUGH STAINS AND 99.9% GERMS IN 1 WASH',
        },
        {
          claim_name: 'CLM-001403',
          claim_statement: 'Test Statement 1',
        },
        {
          claim_name: 'CLM-001820',
          claim_statement:
            'Kills 99% germs\nKills 99% germs\nKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germs\nKills 99% germs\nKills 99% germs\nKills 99% germs\nKills 99% germsKills 99% germs.',
        },
        {
          claim_name: 'CLM-001821',
          claim_statement: 'stainlifters test',
        },
        {
          claim_name: 'CLM-000894',
          claim_statement: 'stainlifters test',
        },
        {
          claim_name: 'CLM-000989',
          claim_statement: 'stainlifters test',
        },
        {
          claim_name: 'CLM-000990',
          claim_statement: 'stainlifters test',
        },
        {
          claim_name: 'CLM-001079',
          claim_statement: 'stainlifters test',
        },
        {
          claim_name: 'CLM-001081',
          claim_statement: 'stainlifters test',
        },
        {
          claim_name: 'CLM-001085',
          claim_statement: 'stainlifters test',
        },
        {
          claim_name: 'CLM-001092',
          claim_statement: 'stainlifters test',
        },
        {
          claim_name: 'CLM-001124',
          claim_statement: 'stainlifters test',
        },
        {
          claim_name: 'CLM-001153',
          claim_statement: 'Statement Image Test',
        },
        {
          claim_name: 'CLM-001163',
          claim_statement: 'Statement Image Test',
        },
        {
          claim_name: 'CLM-001166',
          claim_statement: 'Statement Image Test',
        },
        {
          claim_name: 'CLM-001211',
          claim_statement: 'Statement Image Test',
        },
        {
          claim_name: 'CLM-001169',
          claim_statement: 'Statement Image Test',
        },
        {
          claim_name: 'CLM-001074',
          claim_statement: 'stainlifters Testing 2',
        },
        {
          claim_name: 'CLM-000003',
          claim_statement: 'stainlifters test',
        },
        {
          claim_name: 'CLM-000004',
          claim_statement: '[stainlifters]',
        },
        {
          claim_name: 'CLM-000005',
          claim_statement: 'This is the Test 100',
        },
        {
          claim_name: 'CLM-000006',
          claim_statement: 'stainlifters Testing 2',
        },
        {
          claim_name: 'CLM-000010',
          claim_statement: 'stainlifters Test 2',
        },
        {
          claim_name: 'CLM-000012',
          claim_statement: 'Freanch Statement',
        },
        {
          claim_name: 'CLM-000013',
          claim_statement: 'Freanch Statement',
        },
        {
          claim_name: 'CLM-000011',
          claim_statement: 'Clean  Fresh Scent',
        },
        {
          claim_name: 'CLM-000019',
          claim_statement: 'Freanch Statement1',
        },
        {
          claim_name: 'CLM-000016',
          claim_statement: 'Test Text 20',
        },
        {
          claim_name: 'CLM-000017',
          claim_statement: 'Test Text 30',
        },
        {
          claim_name: 'CLM-000018',
          claim_statement: 'Freanch Statement1',
        },
        {
          claim_name: 'CLM-000020',
          claim_statement: 'This is good product',
        },
        {
          claim_name: 'CLM-000022',
          claim_statement: 'Freanch Statement',
        },
        {
          claim_name: 'CLM-000021',
          claim_statement: '[stainlifters]',
        },
        {
          claim_name: 'CLM-000023',
          claim_statement: 'Vim2',
        },
        {
          claim_name: 'CLM-000024',
          claim_statement: 'Test Text 2024 Validation Rule',
        },
        {
          claim_name: 'CLM-000025',
          claim_statement: 'Freanch Statement',
        },
        {
          claim_name: 'CLM-000026',
          claim_statement:
            'Kills 99% germs\nKills 99% germs\nKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germs\nKills 99% germs\nKills 99% germs\nKills 99% germs\nKills 99% germsKills 99% germs.',
        },
        {
          claim_name: 'CLM-000027',
          claim_statement: 'Test Text 2024 Validation Rule',
        },
        {
          claim_name: 'CLM-000028',
          claim_statement: 'Freanch Statement',
        },
        {
          claim_name: 'CLM-000029',
          claim_statement: 'This is good product',
        },
        {
          claim_name: 'CLM-000030',
          claim_statement: 'Tese 1',
        },
        {
          claim_name: 'CLM-000033',
          claim_statement: 'Test',
        },
        {
          claim_name: 'CLM-000035',
          claim_statement: 'This is for testing Purpose',
        },
        {
          claim_name: 'CLM-000036',
          claim_statement: 'This is for testing Purpose',
        },
        {
          claim_name: 'CLM-000039',
          claim_statement: 'Freanch Statement',
        },
        {
          claim_name: 'CLM-000040',
          claim_statement: 'Freanch Statement1',
        },
        {
          claim_name: 'CLM-000041',
          claim_statement: 'stainlifters Testing 2',
        },
        {
          claim_name: 'CLM-000042',
          claim_statement: 'stainlifters test',
        },
        {
          claim_name: 'CLM-001987',
          claim_statement:
            'Kills 99% germs\nKills 99% germs\nKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germs\nKills 99% germs\nKills 99% germs\nKills 99% germs\nKills 99% germsKills 99% germs.',
        },
        {
          claim_name: 'CLM-001999',
          claim_statement: 'stainlifters test',
        },
        {
          claim_name: 'CLM-002079',
          claim_statement: 'stainlifters test',
        },
        {
          claim_name: 'CLM-002098',
          claim_statement: 'stainlifters test',
        },
        {
          claim_name: 'CLM-002176',
          claim_statement: 'stainlifters test',
        },
        {
          claim_name: 'CLM-002258',
          claim_statement: 'stainlifters test',
        },
        {
          claim_name: 'CLM-002508',
          claim_statement:
            'Kills 99% germs\nKills 99% germs\nKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germs\nKills 99% germs\nKills 99% germs\nKills 99% germs\nKills 99% germsKills 99% germs.',
        },
        {
          claim_name: 'CLM-002520',
          claim_statement: 'stainlifters test',
        },
        {
          claim_name: 'CLM-003055',
          claim_statement: 'Eliminates visible and invisible dirt',
        },
        {
          claim_name: 'CLM-003086',
          claim_statement: 'Eliminates visible and invisible dirt',
        },
        {
          claim_name: 'CLM-000624',
          claim_statement: 'This is the Test 100',
        },
        {
          claim_name: 'CLM-002925',
          claim_statement: 'Kills 99% germs',
        },
        {
          claim_name: 'CLM-002946',
          claim_statement: 'Eliminates visible and invisible dirt',
        },
        {
          claim_name: 'CLM-003116',
          claim_statement: 'Eliminates visible and invisible dirt',
        },
        {
          claim_name: 'CLM-003153',
          claim_statement: 'Smooth and Silky',
        },
        {
          claim_name: 'CLM-003128',
          claim_statement: 'Kills 99% germs',
        },
        {
          claim_name: 'CLM-003149',
          claim_statement: 'Eliminates visible and invisible dirt',
        },
        {
          claim_name: 'CLM-003133',
          claim_statement: 'Freanch Statement',
        },
        {
          claim_name: 'CLM-003161',
          claim_statement: 'Kills 99% germs',
        },
        {
          claim_name: 'CLM-003182',
          claim_statement: 'Eliminates visible and invisible dirt',
        },
        {
          claim_name: 'CLM-003401',
          claim_statement: 'Statement Image Test',
        },
        {
          claim_name: 'CLM-003343',
          claim_statement: 'stainlifters Testing 2',
        },
        {
          claim_name: 'CLM-003397',
          claim_statement: 'Eliminates visible and invisible dirt',
        },
        {
          claim_name: 'CLM-003472',
          claim_statement: 'Statement Image Test',
        },
        {
          claim_name: 'CLM-003505',
          claim_statement: 'stainlifters Testing 2',
        },
        {
          claim_name: 'CLM-003459',
          claim_statement: 'Eliminates visible and invisible dirt',
        },
        {
          claim_name: 'CLM-003559',
          claim_statement: 'Statement Image Test',
        },
        {
          claim_name: 'CLM-003598',
          claim_statement: 'stainlifters Testing 2',
        },
        {
          claim_name: 'CLM-003597',
          claim_statement: 'Eliminates visible and invisible dirt',
        },
        {
          claim_name: 'CLM-003491',
          claim_statement: '100% unbeatable* streak-free shine',
        },
        {
          claim_name: 'CLM-003971',
          claim_statement: 'stainlifters test',
        },
        {
          claim_name: 'CLM-002191',
          claim_statement:
            '*Vs. UK market leader in bathroom sprays ** Tested on most common kitchen surfaces',
        },
        {
          claim_name: 'CLM-004104',
          claim_statement: 'stainlifters test',
        },
        {
          claim_name: 'CLM-004181',
          claim_statement: 'stainlifters test',
        },
        {
          claim_name: 'CLM-004154',
          claim_statement:
            '*Vs. UK market leader in bathroom sprays ** Tested on most common kitchen surfaces',
        },
        {
          claim_name: 'CLM-004429',
          claim_statement: 'Statement Image Test',
        },
        {
          claim_name: 'CLM-004377',
          claim_statement: 'stainlifters Testing 2',
        },
        {
          claim_name: 'CLM-004376',
          claim_statement: 'Eliminates visible and invisible dirt',
        },
        {
          claim_name: 'CLM-003805',
          claim_statement: 'Created from SPARCi by Madhu',
        },
        {
          claim_name: 'CLM-004700',
          claim_statement: 'Vim2',
        },
        {
          claim_name: 'CLM-004647',
          claim_statement: 'Freanch Statement',
        },
        {
          claim_name: 'CLM-004699',
          claim_statement: 'Test Text 2024 Validation Rule',
        },
      ],
      related_products: [
        'Surf Excel Matic Std Liquid test1 To Copy 3',
        'TRESemme Conditioner TRESemmé Silky & Smooth Conditioner',
        'All Concentrated Washing Liquid Fresh & Sensitive',
        'Arisco Universal Seasoning Carne',
        'Arisco Vinegar To Copy Variant 4',
        'Arisco Vinegar To Variant 2',
        'Arisco Vinegar To Copy Variant 6',
        'TRESemme Shampoo Ultra To Copy Test 2',
        'Dove Conditioner new',
        'TRESemme Shampoo TRESemmé Rich Moisture Shampoo',
        'Arisco Vinegar 2025_2',
        'TRESemme Shampoo TRESemme Rich Moisture Shampoo order Variant Create 1',
        'Dove Mask new',
        'TRESemme Shampoo Daily moisture',
        'TRESemme Shampoo TRESemme Rich Moisture Shampoo order To Copy Demo 2.',
        'TRESemme Shampoo TRESemmé Silky & Smooth Shampoo 2',
        'Vaseline Body Lotion Intensive Care / Soothing Hydration',
        'Arisco Vinegar To Variant 3 Variant 1',
        "Pond's Men Face Wash Foam Brightening & Anti Dark Spot",
        'Dove Antiperspirant Aerosol Spray Advanced Care Name Update 3 TRESemmé Color Revitalise Shampoo',
        'Surf Excel Matic Std Liquid Test',
        'TRESemme Conditioner smooth TRESemmé Rich Moisture Conditioner',
        'Cif Abrasive Cream ORIGINAL',
        "Ben & Jerry's Ice Cream Pint flavour",
        'Comfort Rinse Cond Std Liquid Wash 10',
        '3D Multiusos Abrasive Powder 3D FLORAL',
        'Brilhante Washing Powder Brilhante Limpeza Total Pó',
        'TRESemme Shampoo TRESemme Rich Moisture Shampoo order To Copy Demo 1',
        'Arisco Vinegar To Copy Variant 6 To COpy Job',
        'TRESemme Non Aerosol Finishing Spray bottle',
        'Omo Concentrated Washing Powder LAVAGEM PERFEITA TORCIDA QUE VIBRA',
        'TRESemme Shampoo TRESemme Rich Moisture Shampoo order',
        'Omo Concentrated Washing Capsules Test',
        'Dove Deo Aero AP Spray dgdfg',
        'Clear Treatment Test',
        'Brilhante Tira Manchas Sem Cloro Utile Fresh Liquid',
        'Dove Oil lotion',
        'Dove Antiperspirant Aerosol Spray Advanced Care Name Update 3 TRESemmé Keratin Color Shampoo',
        'Comfort Concentrated Washing Powder Test 431',
        'Omo Liquid Ultra Power',
        'Dove Deo Aero AP Advanced Care To Copy test 3',
        'Dove Shampoo Daily Moisture',
        'Shield Anti-Perspirant Fresh Musk',
        'TRESemme Shampoo TRESemme Rich Moisture Shampoo order To Variant 3',
      ],
      related_projects: ['Cancelled_Cancelled_Cancelled_test'],
      'substantiation__vr.description__v': 'Smooth and Silky',
      'substantiation__vr.name__v': 'SUB-000003',
    },
    {
      'claim__vr.related_projects__c': 'Check_Data\nCopy of Check_Data',
      document_id: '3501',
      document_link:
        'https://sb-unilever-claims.veevavault.com/ui/#doc_info/3501/2/0',
      related_claims: [
        {
          claim_name: 'CLM-000053',
          claim_statement: 'Freanch Statement',
        },
        {
          claim_name: 'CLM-000860',
          claim_statement: 'Now you can have it all',
        },
        {
          claim_name: 'CLM-000912',
          claim_statement:
            'New all® fresh & sensitive™ has a clean  fresh hypoallergenic scent  so its gentle on skin  but tough on stains. Now you can have it all.',
        },
        {
          claim_name: 'CLM-000915',
          claim_statement: 'Faster Stain Removal',
        },
        {
          claim_name: 'CLM-000822',
          claim_statement: 'REMOVES TOUGH STAINS AND 99.9% GERMS IN 1 WASH',
        },
        {
          claim_name: 'CLM-001505',
          claim_statement: 'Disclaimer to be incorporated.',
        },
        {
          claim_name: 'CLM-000979',
          claim_statement:
            'Experience the soothing fragrance of new Bold 2in1 Lavender & Camomile Gel',
        },
        {
          claim_name: 'CLM-000980',
          claim_statement: 'Biodegradable ingredients',
        },
        {
          claim_name: 'CLM-000981',
          claim_statement:
            'biodegradable pouch makes these premeasured packs super convenient, without any mess or waste',
        },
        {
          claim_name: 'CLM-000982',
          claim_statement:
            'Kills 99% germs\nKills 99% germs\nKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germsKills 99% germs\nKills 99% germs\nKills 99% germs\nKills 99% germs\nKills 99% germsKills 99% germs.',
        },
        {
          claim_name: 'CLM-000983',
          claim_statement: 'BREEZE',
        },
        {
          claim_name: 'CLM-000985',
          claim_statement: 'BREEZE LIQUID DETERGENT',
        },
        {
          claim_name: 'CLM-000986',
          claim_statement: 'REMOVES STAINS 2X MORE POWER THAN POWDER',
        },
        {
          claim_name: 'CLM-000988',
          claim_statement:
            'biodegradable pouch makes these premeasured packs super convenient, without any mess or waste',
        },
        {
          claim_name: 'CLM-000991',
          claim_statement: 'Beautifully clean & shiny kichen',
        },
        {
          claim_name: 'CLM-000993',
          claim_statement: 'Test Text 2024 Validation Rule',
        },
        {
          claim_name: 'CLM-000994',
          claim_statement: 'Test1',
        },
        {
          claim_name: 'CLM-000995',
          claim_statement: 'Test3',
        },
        {
          claim_name: 'CLM-000996',
          claim_statement: 'fresh & sensitive dyc-free 66 LOADS',
        },
        {
          claim_name: 'CLM-000997',
          claim_statement: 'Gentle on Skin',
        },
        {
          claim_name: 'CLM-000999',
          claim_statement: 'Fresh® Scent',
        },
        {
          claim_name: 'CLM-001002',
          claim_statement: 'Fresh® Scent',
        },
        {
          claim_name: 'CLM-001003',
          claim_statement:
            'How to use: Coat hair with liberal amount of shampoo. Gently massage the scalp and roots into rich lather. Rinse Thoroughly. Finish with TRESemmÃ© SILKY & SMOOTH conditioner for locked in hydrated smoothness.',
        },
        {
          claim_name: 'CLM-001004',
          claim_statement:
            'TRESemmÃ© COLOR REVITALISE System penetrates dyed strands to replenish moisture and seal in color for up to 8 weeks vibrancy, ready to take on any style.',
        },
        {
          claim_name: 'CLM-001006',
          claim_statement: 'Test',
        },
        {
          claim_name: 'CLM-001007',
          claim_statement: 'Sample',
        },
        {
          claim_name: 'CLM-001010',
          claim_statement: '100% oil and grease stain removal',
        },
        {
          claim_name: 'CLM-001011',
          claim_statement: 'Dermatologist Tested',
        },
        {
          claim_name: 'CLM-001013',
          claim_statement: 'Eliminates visible and invisible dirt',
        },
        {
          claim_name: 'CLM-000998',
          claim_statement: 'Clean,',
        },
        {
          claim_name: 'CLM-001000',
          claim_statement: 'Gentle on Skin',
        },
        {
          claim_name: 'CLM-001001',
          claim_statement: 'Clean,',
        },
        {
          claim_name: 'CLM-001005',
          claim_statement:
            'How to use: Coat hair with liberal amount of shampoo. Gently massage the scalp and roots into rich lather. Rinse Thoroughly. Finish with TRESemmÃ© RICH MOISTURE conditioner for rich nourishing care.',
        },
        {
          claim_name: 'CLM-001008',
          claim_statement: 'Example',
        },
        {
          claim_name: 'CLM-001009',
          claim_statement: '100% unbeatable* streak-free shine',
        },
        {
          claim_name: 'CLM-001012',
          claim_statement: 'Pro Collection',
        },
        {
          claim_name: 'CLM-001014',
          claim_statement: 'Dermatologist Tested',
        },
        {
          claim_name: 'CLM-001015',
          claim_statement: 'Pro Collection',
        },
        {
          claim_name: 'CLM-001016',
          claim_statement: 'Eliminates visible and invisible dirt',
        },
        {
          claim_name: 'CLM-001017',
          claim_statement: 'WITH LONG LASTING FRAGRANCE',
        },
        {
          claim_name: 'CLM-001018',
          claim_statement: '100% unbeatable* streak-free shine',
        },
        {
          claim_name: 'CLM-001022',
          claim_statement: 'Test2',
        },
        {
          claim_name: 'CLM-001023',
          claim_statement: 'Surf excel MATIC',
        },
        {
          claim_name: 'CLM-001025',
          claim_statement: 'Test Ira Veeva Save',
        },
        {
          claim_name: 'CLM-001026',
          claim_statement: 'Test2',
        },
        {
          claim_name: 'CLM-001027',
          claim_statement: 'Clean  Fresh Scent',
        },
        {
          claim_name: 'CLM-001028',
          claim_statement: 'Test2',
        },
        {
          claim_name: 'CLM-001035',
          claim_statement: 'Test2',
        },
        {
          claim_name: 'CLM-001019',
          claim_statement: 'NEW FRONT LOAD',
        },
        {
          claim_name: 'CLM-001020',
          claim_statement: 'Sample',
        },
        {
          claim_name: 'CLM-001021',
          claim_statement: 'Test',
        },
        {
          claim_name: 'CLM-001024',
          claim_statement: '3X TOUGH STAINS',
        },
        {
          claim_name: 'CLM-001029',
          claim_statement: 'Test Statement',
        },
        {
          claim_name: 'CLM-001030',
          claim_statement: 'WITH LONG LASTING FRAGRANCE',
        },
        {
          claim_name: 'CLM-001031',
          claim_statement: '100% unbeatable* streak-free shine',
        },
        {
          claim_name: 'CLM-001032',
          claim_statement: 'Test statement for ira review',
        },
        {
          claim_name: 'CLM-001033',
          claim_statement: 'Silk Touch',
        },
        {
          claim_name: 'CLM-001034',
          claim_statement: 'സർഫ് എക്സൽ MATIC',
        },
        {
          claim_name: 'CLM-001036',
          claim_statement: 'Test3',
        },
        {
          claim_name: 'CLM-001037',
          claim_statement: 'Ar 200',
        },
        {
          claim_name: 'CLM-001038',
          claim_statement:
            'The April Fresh® you love in a Limited Edition bottle.',
        },
        {
          claim_name: 'CLM-001040',
          claim_statement: 'Bright like new',
        },
        {
          claim_name: 'CLM-001044',
          claim_statement: 'Sanitizes and fights bad odor',
        },
        {
          claim_name: 'CLM-001046',
          claim_statement: 'This is a test claim 1',
        },
        {
          claim_name: 'CLM-001047',
          claim_statement: 'This is a test claim 2',
        },
        {
          claim_name: 'CLM-001048',
          claim_statement: 'This is a test claim 3',
        },
        {
          claim_name: 'CLM-001053',
          claim_statement: 'Biodegradable ingredients',
        },
        {
          claim_name: 'CLM-001054',
          claim_statement:
            'biodegradable pouch makes these premeasured packs super convenient, without any mess or waste',
        },
        {
          claim_name: 'CLM-001056',
          claim_statement: 'Rın',
        },
        {
          claim_name: 'CLM-001057',
          claim_statement: 'BRIGHT LIRE NEW',
        },
        {
          claim_name: 'CLM-001058',
          claim_statement: 'Keep shining',
        },
        {
          claim_name: 'CLM-001062',
          claim_statement: 'CONTEM 800 g LAVA ROUPAS EM PÓ',
        },
        {
          claim_name: 'CLM-001063',
          claim_statement: 'Test1',
        },
        {
          claim_name: 'CLM-001064',
          claim_statement: 'Test3',
        },
        {
          claim_name: 'CLM-001066',
          claim_statement: 'This is LA Testing to Save Translations',
        },
        {
          claim_name: 'CLM-001039',
          claim_statement: '*Disclaimer to be incorporated',
        },
        {
          claim_name: 'CLM-001041',
          claim_statement: 'Keep shining',
        },
        {
          claim_name: 'CLM-001043',
          claim_statement: 'Sample',
        },
        {
          claim_name: 'CLM-001045',
          claim_statement: 'Machine and Colour care',
        },
        {
          claim_name: 'CLM-001049',
          claim_statement: 'This is a test claim 4',
        },
        {
          claim_name: 'CLM-001050',
          claim_statement: 'This is a test claim 5',
        },
        {
          claim_name: 'CLM-001051',
          claim_statement: 'This is a test claim 6',
        },
        {
          claim_name: 'CLM-001052',
          claim_statement: 'My Own GB Translation',
        },
        {
          claim_name: 'CLM-001055',
          claim_statement: 'Bright like new*',
        },
        {
          claim_name: 'CLM-001059',
          claim_statement: '"Disclaimer to be incorporated',
        },
        {
          claim_name: 'CLM-001060',
          claim_statement: 'IMBATÍVEL NA LIMPEZA',
        },
        {
          claim_name: 'CLM-001061',
          claim_statement: 'CUIDA DO MEIO AMBIENTE',
        },
        {
          claim_name: 'CLM-001065',
          claim_statement: 'Stainlifters test 3',
        },
        {
          claim_name: 'CLM-001067',
          claim_statement: 'This is LA Testing to Save Translations',
        },
        {
          claim_name: 'CLM-001068',
          claim_statement: 'This is LA Testing 10',
        },
        {
          claim_name: 'CLM-001080',
          claim_statement: 'Allergen Free EEOC',
        },
        {
          claim_name: 'CLM-001083',
          claim_statement: 'This is the Test 100',
        },
        {
          claim_name: 'CLM-001087',
          claim_statement: 'stainlifters Test 2',
        },
        {
          claim_name: 'CLM-001089',
          claim_statement: 'Keep shining',
        },
        {
          claim_name: 'CLM-001090',
          claim_statement: 'Rin',
        },
        {
          claim_name: 'CLM-001100',
          claim_statement: 'Testing the LA Creation',
        },
        {
          claim_name: 'CLM-001101',
          claim_statement: 'Testing the LA Creation 2',
        },
        {
          claim_name: 'CLM-001102',
          claim_statement: 'Test3',
        },
        {
          claim_name: 'CLM-001105',
          claim_statement: 'Test1',
        },
        {
          claim_name: 'CLM-001069',
          claim_statement: 'Claim 2',
        },
        {
          claim_name: 'CLM-001070',
          claim_statement: 'Claim 3',
        },
        {
          claim_name: 'CLM-001071',
          claim_statement: 'Claim 1',
        },
        {
          claim_name: 'CLM-001072',
          claim_statement: 'Test Text 30',
        },
        {
          claim_name: 'CLM-001073',
          claim_statement: 'This is good product',
        },
        {
          claim_name: 'CLM-001075',
          claim_statement: 'Freanch Statement1',
        },
        {
          claim_name: 'CLM-001076',
          claim_statement: 'Tese 3',
        },
        {
          claim_name: 'CLM-001077',
          claim_statement: 'Test Text 20',
        },
        {
          claim_name: 'CLM-001078',
          claim_statement: 'This is for testing Purpose',
        },
        {
          claim_name: 'CLM-001082',
          claim_statement: 'Allergen Free EEOC',
        },
        {
          claim_name: 'CLM-001086',
          claim_statement: 'Allergen Free EEOC',
        },
        {
          claim_name: 'CLM-001091',
          claim_statement: 'This is the Test 100',
        },
        {
          claim_name: 'CLM-001088',
          claim_statement: 'Disclaimer to be incorporated',
        },
        {
          claim_name: 'CLM-001094',
          claim_statement: 'Test10',
        },
        {
          claim_name: 'CLM-001095',
          claim_statement: 'Brilliant clean in 1 wash',
        },
        {
          claim_name: 'CLM-001096',
          claim_statement: 'BRIGHTGUARD',
        },
        {
          claim_name: 'CLM-001099',
          claim_statement: 'novas limpezas de lavagem',
        },
        {
          claim_name: 'CLM-001103',
          claim_statement: 'Example',
        },
        {
          claim_name: 'CLM-001104',
          claim_statement: 'Test2',
        },
        {
          claim_name: 'CLM-001106',
          claim_statement: 'Freanch Statement',
        },
        {
          claim_name: 'CLM-001107',
          claim_statement: 'Smooth and Silky',
        },
        {
          claim_name: 'CLM-001108',
          claim_statement: 'Bright like new*',
        },
        {
          claim_name: 'CLM-001109',
          claim_statement: '"Disclaimer to be incorporated',
        },
        {
          claim_name: 'CLM-001110',
          claim_statement: 'Stainlifters test 3',
        },
        {
          claim_name: 'CLM-001111',
          claim_statement: 'Example',
        },
        {
          claim_name: 'CLM-001112',
          claim_statement: 'Keep shining',
        },
        {
          claim_name: 'CLM-001113',
          claim_statement: '100% unbeatable* streak-free shine',
        },
        {
          claim_name: 'CLM-001114',
          claim_statement: 'Rin',
        },
        {
          claim_name: 'CLM-001115',
          claim_statement: 'Bright like new*',
        },
        {
          claim_name: 'CLM-001116',
          claim_statement: '100% oil and grease stain removal',
        },
        {
          claim_name: 'CLM-001117',
          claim_statement: 'New Test Statement debug claims generation issue',
        },
        {
          claim_name: 'CLM-001118',
          claim_statement: 'Test3',
        },
        {
          claim_name: 'CLM-001119',
          claim_statement: 'stainlifter*',
        },
        {
          claim_name: 'CLM-001120',
          claim_statement: 'Test1',
        },
        {
          claim_name: 'CLM-001121',
          claim_statement: "NOW WITH IN-WASH PRE-TREATERS'",
        },
        {
          claim_name: 'CLM-001122',
          claim_statement: 'Sample',
        },
        {
          claim_name: 'CLM-001123',
          claim_statement: 'Keep shining',
        },
        {
          claim_name: 'CLM-001125',
          claim_statement: 'BRIGHT LIRE NEW',
        },
        {
          claim_name: 'CLM-001126',
          claim_statement: 'Rın',
        },
        {
          claim_name: 'CLM-001127',
          claim_statement: 'Test Text 2024 Validation Rule',
        },
        {
          claim_name: 'CLM-001128',
          claim_statement: 'Vim2',
        },
        {
          claim_name: 'CLM-001129',
          claim_statement: 'Tese 2',
        },
        {
          claim_name: 'CLM-001130',
          claim_statement: 'soft and shiny',
        },
        {
          claim_name: 'CLM-001131',
          claim_statement: 'Test10',
        },
        {
          claim_name: 'CLM-001132',
          claim_statement: 'Disclaimer to be incorporated',
        },
        {
          claim_name: 'CLM-001133',
          claim_statement: 'Example',
        },
        {
          claim_name: 'CLM-001134',
          claim_statement: 'Beautifully clean & shiny kichen',
        },
        {
          claim_name: 'CLM-001135',
          claim_statement: 'Test3',
        },
        {
          claim_name: 'CLM-001136',
          claim_statement: 'Test2',
        },
        {
          claim_name: 'CLM-001137',
          claim_statement: 'Test1',
        },
        {
          claim_name: 'CLM-001138',
          claim_statement: 'Machine and Colour care',
        },
        {
          claim_name: 'CLM-001139',
          claim_statement: 'Tese 1',
        },
        {
          claim_name: 'CLM-001140',
          claim_statement: 'This is a test claim 4',
        },
        {
          claim_name: 'CLM-001141',
          claim_statement: 'This is a test claim 5',
        },
        {
          claim_name: 'CLM-001142',
          claim_statement: 'This is the Test 100',
        },
        {
          claim_name: 'CLM-001143',
          claim_statement: 'Clean  Fresh Scent',
        },
        {
          claim_name: 'CLM-001144',
          claim_statement: 'This is a test claim 6',
        },
        {
          claim_name: 'CLM-001145',
          claim_statement: 'Test2',
        },
        {
          claim_name: 'CLM-001146',
          claim_statement: 'This is a test claim 3',
        },
        {
          claim_name: 'CLM-001147',
          claim_statement: 'This is a test claim 2',
        },
        {
          claim_name: 'CLM-001148',
          claim_statement: 'This is a test claim 1',
        },
        {
          claim_name: 'CLM-001149',
          claim_statement: 'Sanitizes and fights bad odor',
        },
        {
          claim_name: 'CLM-001150',
          claim_statement: '100% unbeatable* streak-free shine',
        },
        {
          claim_name: 'CLM-001151',
          claim_statement: '[stainlifters]',
        },
        {
          claim_name: 'CLM-001152',
          claim_statement: 'Super Soak Technology FOR SUPER STAIN REMOVAL',
        },
        {
          claim_name: 'CLM-001157',
          claim_statement: 'Test',
        },
        {
          claim_name: 'CLM-001162',
          claim_statement: 'Now you can have it all',
        },
        {
          claim_name: 'CLM-001193',
          claim_statement: 'Simple Creation of object with no Translations',
        },
        {
          claim_name: 'CLM-001195',
          claim_statement:
            'Simple Creation of object with Translations of same language',
        },
        {
          claim_name: 'CLM-001197',
          claim_statement:
            'ഇംഗ്ലീഷ് ഇതര പ്രസ്താവനയുള്ള ഒബ്ജക്റ്റിൻ്റെ ലളിതമായ സൃഷ്ടി',
        },
        {
          claim_name: 'CLM-001199',
          claim_statement: 'This is good product',
        },
        {
          claim_name: 'CLM-001200',
          claim_statement: 'Vim2',
        },
        {
          claim_name: 'CLM-001205',
          claim_statement: 'Simple Creation of object with English-English',
        },
        {
          claim_name: 'CLM-001212',
          claim_statement: 'Freanch Statement1',
        },
        {
          claim_name: 'CLM-001214',
          claim_statement: 'Testing Save Veeva API',
        },
        {
          claim_name: 'CLM-001215',
          claim_statement: 'stainlifters Test 2',
        },
        {
          claim_name: 'CLM-001217',
          claim_statement:
            '*Vs. UK market leader in bathroom sprays ** Tested on most common kitchen surfaces',
        },
        {
          claim_name: 'CLM-001222',
          claim_statement: 'yest Cl;aim 2',
        },
        {
          claim_name: 'CLM-001154',
          claim_statement: 'Test',
        },
        {
          claim_name: 'CLM-001155',
          claim_statement: 'Test1',
        },
        {
          claim_name: 'CLM-001156',
          claim_statement: 'Test2',
        },
        {
          claim_name: 'CLM-001165',
          claim_statement:
            'ക്രോസ് ലാംഗ്വേജിൽ ഒബ്‌ജക്‌റ്റുകൾ സൃഷ്‌ടിക്കുന്നത് പരിശോധിക്കുന്നു',
        },
        {
          claim_name: 'CLM-001194',
          claim_statement: 'Simple Creation of object with Translations',
        },
        {
          claim_name: 'CLM-001196',
          claim_statement: 'Test Back Translator',
        },
        {
          claim_name: 'CLM-001201',
          claim_statement: 'Clean  Fresh Scent',
        },
        {
          claim_name: 'CLM-001202',
          claim_statement: 'daag achhe hain',
        },
        {
          claim_name: 'CLM-001203',
          claim_statement:
            'SURF EXCEL LIQUID Removes stain 2X better than powders',
        },
        {
          claim_name: 'CLM-001204',
          claim_statement: 'Testing LA in Dev',
        },
        {
          claim_name: 'CLM-001206',
          claim_statement: 'Testing LA in Dev',
        },
        {
          claim_name: 'CLM-001207',
          claim_statement: 'Testing Translated Qualifiersss',
        },
        {
          claim_name: 'CLM-001208',
          claim_statement: 'Testing Save Veeva API',
        },
        {
          claim_name: 'CLM-001209',
          claim_statement: 'Simple Creation of object with English-English',
        },
        {
          claim_name: 'CLM-001210',
          claim_statement: 'Testing 6th Scenario',
        },
        {
          claim_name: 'CLM-001213',
          claim_statement: 'Vim2',
        },
        {
          claim_name: 'CLM-001216',
          claim_statement: 'Test5',
        },
        {
          claim_name: 'CLM-001218',
          claim_statement: 'Kitchen Cleaner Benefits',
        },
        {
          claim_name: 'CLM-001219',
          claim_statement: 'Beautifully clean & shiny kichen',
        },
        {
          claim_name: 'CLM-001220',
          claim_statement: '100% unbeatable* streak-free shine',
        },
        {
          claim_name: 'CLM-001221',
          claim_statement: '100% oil and grease stain removal',
        },
        {
          claim_name: 'CLM-001223',
          claim_statement: 'Test Claim 1',
        },
        {
          claim_name: 'CLM-001158',
          claim_statement: 'Claim 2',
        },
        {
          claim_name: 'CLM-001159',
          claim_statement: 'Claim 1',
        },
        {
          claim_name: 'CLM-001160',
          claim_statement: 'Claim 3',
        },
        {
          claim_name: 'CLM-001161',
          claim_statement: 'Claim 4',
        },
        {
          claim_name: 'CLM-001182',
          claim_statement: 'Now you can have it all',
        },
        {
          claim_name: 'CLM-001183',
          claim_statement: 'Free of Perfumes',
        },
        {
          claim_name: 'CLM-001184',
          claim_statement: 'The SAFE FOR ALL WASHERS',
        },
        {
          claim_name: 'CLM-001185',
          claim_statement: 'Free of Dyes',
        },
        {
          claim_name: 'CLM-001188',
          claim_statement: 'new from the #1',
        },
        {
          claim_name: 'CLM-001224',
          claim_statement: 'Test Back translation Formatted statement',
        },
        {
          claim_name: 'CLM-001226',
          claim_statement: 'Simple Creation of object with English-English',
        },
        {
          claim_name: 'CLM-001228',
          claim_statement: '₹ 10/: WEEKLY PACK',
        },
        {
          claim_name: 'CLM-001229',
          claim_statement: 'POWER OF 108 LEMONS',
        },
        {
          claim_name: 'CLM-001233',
          claim_statement: 'POWER OF 100 LEMONS',
        },
        {
          claim_name: 'CLM-001237',
          claim_statement: 'Vim Liquid Wash',
        },
        {
          claim_name: 'CLM-001225',
          claim_statement: 'Test123',
        },
        {
          claim_name: 'CLM-001227',
          claim_statement: 'This is a child creation in English',
        },
        {
          claim_name: 'CLM-001230',
          claim_statement: '₹ 20/-',
        },
        {
          claim_name: 'CLM-001231',
          claim_statement: 'Vim',
        },
        {
          claim_name: 'CLM-001232',
          claim_statement: 'Concentrated Cal',
        },
        {
          claim_name: 'CLM-001234',
          claim_statement: 'Vim Liquid',
        },
        {
          claim_name: 'CLM-001235',
          claim_statement: 'Vim Liquid',
        },
        {
          claim_name: 'CLM-001236',
          claim_statement: 'Concentrated Cal',
        },
        {
          claim_name: 'CLM-001238',
          claim_statement: 'Test',
        },
        {
          claim_name: 'CLM-001239',
          claim_statement: 'Test1',
        },
        {
          claim_name: 'CLM-001246',
          claim_statement: 'Test1',
        },
        {
          claim_name: 'CLM-001251',
          claim_statement: 'lavagemperfeita',
        },
        {
          claim_name: 'CLM-001257',
          claim_statement:
            'ATIVO CONCENTRADO TECNOLOGIA QUE CUIDA DO MEIO AMBIENTE',
        },
        {
          claim_name: 'CLM-001259',
          claim_statement:
            'Fácil de usar: após lavar com detergentes, despeje 1/2 tampa de conforto em um balde de água e molhe as roupas por 5 minutos.',
        },
        {
          claim_name: 'CLM-001262',
          claim_statement: 'Bright like new*',
        },
        {
          claim_name: 'CLM-001264',
          claim_statement: 'Keep shining',
        },
        {
          claim_name: 'CLM-001268',
          claim_statement: '100% oil and grease stain removal',
        },
        {
          claim_name: 'CLM-001269',
          claim_statement: 'BRIGHT LIRE NEW',
        },
        {
          claim_name: 'CLM-001270',
          claim_statement: 'Disclaimer to be incorporated',
        },
        {
          claim_name: 'CLM-001271',
          claim_statement: 'Keep shining',
        },
        {
          claim_name: 'CLM-001273',
          claim_statement: 'Keep shining',
        },
        {
          claim_name: 'CLM-001274',
          claim_statement: 'Bright like new*',
        },
        {
          claim_name: 'CLM-001275',
          claim_statement: 'Disclaimer to be incorporated.',
        },
        {
          claim_name: 'CLM-001277',
          claim_statement: 'Test4',
        },
        {
          claim_name: 'CLM-001279',
          claim_statement: 'Test1',
        },
        {
          claim_name: 'CLM-001280',
          claim_statement: 'Test1',
        },
        {
          claim_name: 'CLM-001283',
          claim_statement:
            'Try the Clean  Fresh Scent that Sensitive skin has been waiting for',
        },
        {
          claim_name: 'CLM-001282',
          claim_statement:
            'New all® fresh & sensitive™ has a clean  fresh hypoallergenic scent  so its gentle on skin  but tough on stains. Now you can have it all.',
        },
        {
          claim_name: 'CLM-001281',
          claim_statement: 'NEW',
        },
        {
          claim_name: 'CLM-001285',
          claim_statement: 'Testing',
        },
        {
          claim_name: 'CLM-001287',
          claim_statement: 'tws',
        },
        {
          claim_name: 'CLM-001288',
          claim_statement:
            'Try the Clean  Fresh Scent that Sensitive skin has been waiting for',
        },
        {
          claim_name: 'CLM-001361',
          claim_statement: '100% GREASE REMOVAL 100% STREAK-FREE SHINE',
        },
        {
          claim_name: 'CLM-001360',
          claim_statement: 'KITCHEN',
        },
        {
          claim_name: 'CLM-001364',
          claim_statement: 'Testing New Changes',
        },
        {
          claim_name: 'CLM-001365',
          claim_statement: 'Testing New Changes',
        },
        {
          claim_name: 'CLM-001375',
          claim_statement: 'Test3',
        },
        {
          claim_name: 'CLM-001377',
          claim_statement: 'RHAMN clean TM 00% PLANT-BASED ACTIVE',
        },
        {
          claim_name: 'CLM-001379',
          claim_statement:
            'ANTIBACTERIAL DISHWASHING LIQUID ANTIBACTÉRIEN LIQUIDE VAISSELLE | ANTIBACTERIANA LOUÇAS LÍQUIDO',
        },
        {
          claim_name: 'CLM-001240',
          claim_statement: 'This is good product',
        },
        {
          claim_name: 'CLM-001241',
          claim_statement: 'Keep shining',
        },
        {
          claim_name: 'CLM-001242',
          claim_statement: 'Bright like new*',
        },
        {
          claim_name: 'CLM-001243',
          claim_statement: 'Disclaimer to be incorporated',
        },
        {
          claim_name: 'CLM-001244',
          claim_statement: 'Keep shining',
        },
        {
          claim_name: 'CLM-001245',
          claim_statement: 'Bright like new*',
        },
        {
          claim_name: 'CLM-001247',
          claim_statement: 'Test3',
        },
        {
          claim_name: 'CLM-001248',
          claim_statement: 'Test2',
        },
        {
          claim_name: 'CLM-001249',
          claim_statement: 'lavagemperfeita',
        },
        {
          claim_name: 'CLM-001250',
          claim_statement: '100% unbeatable* streak-free shine',
        },
        {
          claim_name: 'CLM-001252',
          claim_statement: 'Imbatível na LIMPEZA cuida do meio ambiente 5 UL',
        },
        {
          claim_name: 'CLM-001253',
          claim_statement: 'IMBATÍVEL NA LIMPEZA',
        },
        {
          claim_name: 'CLM-001254',
          claim_statement: 'CUIDA DO MEIO AMBIENTE',
        },
        {
          claim_name: 'CLM-001255',
          claim_statement: 'CONTEM 800 g LAVA ROUPAS EM PÓ',
        },
        {
          claim_name: 'CLM-001256',
          claim_statement:
            '800g RENDE PÓ ULTRAFINO IGUAL 1 kg NÃO DEIXA RESÍDUOS',
        },
        {
          claim_name: 'CLM-001258',
          claim_statement:
            'Frescura duradoura: agora com pérolas perfumadas para uma frescura duradoura.',
        },
        {
          claim_name: 'CLM-001260',
          claim_statement: 'Bright like new',
        },
        {
          claim_name: 'CLM-001261',
          claim_statement: 'Bright like new',
        },
        {
          claim_name: 'CLM-001263',
          claim_statement: 'Disclaimer to be incorporated.',
        },
        {
          claim_name: 'CLM-001265',
          claim_statement: 'Beautifully clean & shiny kichen',
        },
        {
          claim_name: 'CLM-001267',
          claim_statement: 'Kitchen Cleaner Benefits',
        },
        {
          claim_name: 'CLM-001266',
          claim_statement:
            '*Vs. UK market leader in bathroom sprays ** Tested on most common kitchen surfaces',
        },
        {
          claim_name: 'CLM-001272',
          claim_statement: 'Bright like new*',
        },
        {
          claim_name: 'CLM-001276',
          claim_statement: 'Test2',
        },
        {
          claim_name: 'CLM-001278',
          claim_statement: 'Test3',
        },
        {
          claim_name: 'CLM-001284',
          claim_statement: 'Testing on Dev',
        },
        {
          claim_name: 'CLM-001286',
          claim_statement: 'Testing1',
        },
        {
          claim_name: 'CLM-001289',
          claim_statement:
            'New all® fresh & sensitive™ has a clean  fresh hypoallergenic scent  so its gentle on skin  but tough on stains. Now you can have it all.',
        },
        {
          claim_name: 'CLM-001290',
          claim_statement: 'NEW',
        },
        {
          claim_name: 'CLM-001291',
          claim_statement: 'Text',
        },
        {
          claim_name: 'CLM-001292',
          claim_statement: 'Test',
        },
        {
          claim_name: 'CLM-001293',
          claim_statement: 'Machine and Colour care',
        },
        {
          claim_name: 'CLM-001363',
          claim_statement: 'Cif POWER & SHINE',
        },
        {
          claim_name: 'CLM-001362',
          claim_statement: 'WITH LIFT ACTION TECHNOLOGY',
        },
        {
          claim_name: 'CLM-001376',
          claim_statement: 'ON SPONGE* AND DISHES^',
        },
        {
          claim_name: 'CLM-001378',
          claim_statement: '99.9% BACTERIA PROTECTION',
        },
        {
          claim_name: 'CLM-001381',
          claim_statement: 'PLATINUM',
        },
        {
          claim_name: 'CLM-001380',
          claim_statement: '24 HR',
        },
        {
          claim_name: 'CLM-001294',
          claim_statement: 'Testing LA in Dev',
        },
        {
          claim_name: 'CLM-001295',
          claim_statement: 'Vim Liquid Wash',
        },
        {
          claim_name: 'CLM-001296',
          claim_statement: 'Simple Creation of object with English-English',
        },
        {
          claim_name: 'CLM-001297',
          claim_statement: 'Vim2',
        },
        {
          claim_name: 'CLM-001298',
          claim_statement: 'This is good product',
        },
        {
          claim_name: 'CLM-001299',
          claim_statement: 'Simple Creation of object with no Translations',
        },
        {
          claim_name: 'CLM-001300',
          claim_statement: 'Testing Translated Qualifiersss',
        },
        {
          claim_name: 'CLM-001301',
          claim_statement:
            'ഇംഗ്ലീഷ് ഇതര പ്രസ്താവനയുള്ള ഒബ്ജക്റ്റിൻ്റെ ലളിതമായ സൃഷ്ടി',
        },
        {
          claim_name: 'CLM-001302',
          claim_statement: 'Test Back Translator',
        },
        {
          claim_name: 'CLM-001303',
          claim_statement:
            'Simple Creation of object with Translations of same language',
        },
        {
          claim_name: 'CLM-001304',
          claim_statement: 'Simple Creation of object with Translations',
        },
        {
          claim_name: 'CLM-001305',
          claim_statement: 'Testing LA in Dev',
        },
        {
          claim_name: 'CLM-001306',
          claim_statement: 'Vim Liquid Wash',
        },
        {
          claim_name: 'CLM-001307',
          claim_statement: 'Simple Creation of object with English-English',
        },
        {
          claim_name: 'CLM-001308',
          claim_statement: 'Vim2',
        },
        {
          claim_name: 'CLM-001309',
          claim_statement: 'This is good product',
        },
        {
          claim_name: 'CLM-001310',
          claim_statement: 'Simple Creation of object with no Translations',
        },
        {
          claim_name: 'CLM-001311',
          claim_statement: 'Testing Translated Qualifiersss',
        },
        {
          claim_name: 'CLM-001312',
          claim_statement:
            'ഇംഗ്ലീഷ് ഇതര പ്രസ്താവനയുള്ള ഒബ്ജക്റ്റിൻ്റെ ലളിതമായ സൃഷ്ടി',
        },
        {
          claim_name: 'CLM-001313',
          claim_statement: 'Test Back Translator',
        },
        {
          claim_name: 'CLM-001314',
          claim_statement:
            'Simple Creation of object with Translations of same language',
        },
        {
          claim_name: 'CLM-001349',
          claim_statement: 'Test Back Translator',
        },
        {
          claim_name: 'CLM-001350',
          claim_statement: 'Testing Translated Qualifiersss',
        },
        {
          claim_name: 'CLM-001351',
          claim_statement:
            'ഇംഗ്ലീഷ് ഇതര പ്രസ്താവനയുള്ള ഒബ്ജക്റ്റിൻ്റെ ലളിതമായ സൃഷ്ടി',
        },
        {
          claim_name: 'CLM-001352',
          claim_statement: 'This is good product',
        },
        {
          claim_name: 'CLM-001353',
          claim_statement: 'Simple Creation of object with no Translations',
        },
        {
          claim_name: 'CLM-001354',
          claim_statement: 'Simple Creation of object with English-English',
        },
        {
          claim_name: 'CLM-001355',
          claim_statement: 'Vim2',
        },
        {
          claim_name: 'CLM-001357',
          claim_statement: 'Vim Liquid Wash',
        },
        {
          claim_name: 'CLM-001358',
          claim_statement:
            'Simple Creation of object with Translations of same language',
        },
        {
          claim_name: 'CLM-001366',
          claim_statement: 'Vim Liquid Wash',
        },
        {
          claim_name: 'CLM-001367',
          claim_statement: 'Vim2',
        },
        {
          claim_name: 'CLM-001368',
          claim_statement: 'Simple Creation of object with no Translations',
        },
        {
          claim_name: 'CLM-001369',
          claim_statement: 'Simple Creation of object with English-English',
        },
        {
          claim_name: 'CLM-001370',
          claim_statement:
            'ഇംഗ്ലീഷ് ഇതര പ്രസ്താവനയുള്ള ഒബ്ജക്റ്റിൻ്റെ ലളിതമായ സൃഷ്ടി',
        },
        {
          claim_name: 'CLM-001371',
          claim_statement: 'This is good product',
        },
        {
          claim_name: 'CLM-001374',
          claim_statement:
            'Simple Creation of object with Translations of same language',
        },
        {
          claim_name: 'CLM-001382',
          claim_statement: '₹ 10/= WEEKLY PACK Vim POWER OF 108 LEMONS',
        },
        {
          claim_name: 'CLM-001383',
          claim_statement: 'I exist with the project',
        },
        {
          claim_name: 'CLM-001384',
          claim_statement: 'I exist with the project',
        },
        {
          claim_name: 'CLM-001386',
          claim_statement: 'Update Claims/LA exist with Surf Excel Product',
        },
        {
          claim_name: 'CLM-001394',
          claim_statement: 'ടെസ്റ്റ് സൃഷ്ടിക്കുന്നതിനുള്ള ഡമ്മി പ്രസ്താവന',
        },
        {
          claim_name: 'CLM-001395',
          claim_statement:
            'This is testing the qualifiers for translated statement 1',
        },
        {
          claim_name: 'CLM-001399',
          claim_statement: 'Sample Statement 1',
        },
        {
          claim_name: 'CLM-001401',
          claim_statement: 'Test4',
        },
        {
          claim_name: 'CLM-001402',
          claim_statement: 'test statement 2',
        },
        {
          claim_name: 'CLM-001385',
          claim_statement: 'Update Claims/LA exist with Product',
        },
        {
          claim_name: 'CLM-001387',
          claim_statement: 'Update Claims/LA exist with Product',
        },
        {
          claim_name: 'CLM-001388',
          claim_statement: 'I am new to this project',
        },
        {
          claim_name: 'CLM-001396',
          claim_statement:
            'This is testing the qualifiers for translated statement 2',
        },
        {
          claim_name: 'CLM-001397',
          claim_statement:
            'This is testing the qualifiers for translated statement',
        },
        {
          claim_name: 'CLM-001398',
          claim_statement: 'LUX',
        },
        {
          claim_name: 'CLM-001400',
          claim_statement: 'Sample Statement',
        },
        {
          claim_name: 'CLM-001403',
          claim_statement: 'Test Statement 1',
        },
        {
          claim_name: 'CLM-001407',
          claim_statement: 'Test2',
        },
        {
          claim_name: 'CLM-001406',
          claim_statement: 'Test3',
        },
        {
          claim_name: 'CLM-001410',
          claim_statement: 'Claim 4',
        },
        {
          claim_name: 'CLM-001411',
          claim_statement: 'Claim 2',
        },
        {
          claim_name: 'CLM-001412',
          claim_statement:
            'This is a claim This is a claim This is a claim This is a claim This is a claim This is a claim This is a claim This is a claim This is a claim This is a claim This is a claim',
        },
        {
          claim_name: 'CLM-001413',
          claim_statement: 'Sample 2 in Kannada',
        },
        {
          claim_name: 'CLM-001415',
          claim_statement: 'Sample 3 in Kannada',
        },
        {
          claim_name: 'CLM-001416',
          claim_statement: 'FABULOUS CLEAN  BEST EVER FRAGRANCE',
        },
        {
          claim_name: 'CLM-001421',
          claim_statement: 'Designed for SHORT CYCLES Even in 15 Minutes',
        },
        {
          claim_name: 'CLM-001422',
          claim_statement: 'NEW Surf MAGNIFI-SCENT WASH',
        },
        {
          claim_name: 'CLM-001405',
          claim_statement: 'Test1',
        },
        {
          claim_name: 'CLM-001404',
          claim_statement: 'Test5',
        },
        {
          claim_name: 'CLM-001408',
          claim_statement:
            'This is a test claim This is a test claim This is a test claim This is a test claim This is a test claim This is a test claim This is a test claim This is a test',
        },
        {
          claim_name: 'CLM-001409',
          claim_statement: 'Claim 3',
        },
        {
          claim_name: 'CLM-001414',
          claim_statement: 'Sample 1 in Kannada',
        },
        {
          claim_name: 'CLM-001417',
          claim_statement: 'SAVE WATER  ENERGY  TIME',
        },
        {
          claim_name: 'CLM-001424',
          claim_statement: 'GOLDEN BLISS',
        },
        {
          claim_name: 'CLM-001419',
          claim_statement: 'SASSY SWIRL',
        },
        {
          claim_name: 'CLM-001418',
          claim_statement: 'ALL IN JUST 15 MINUTES',
        },
        {
          claim_name: 'CLM-001423',
          claim_statement: 'FLIRTY FLORALS',
        },
        {
          claim_name: 'CLM-001814',
          claim_statement: 'Simple Creation of object with English-English',
        },
        {
          claim_name: 'CLM-001812',
          claim_statement: 'This is good product',
        },
        {
          claim_name: 'CLM-001813',
          claim_statement: 'Simple Creation of object with no Translations',
        },
        {
          claim_name: 'CLM-001810',
          claim_statement: 'Testing Translated Qualifiersss',
        },
        {
          claim_name: 'CLM-001811',
          claim_statement:
            'ഇംഗ്ലീഷ് ഇതര പ്രസ്താവനയുള്ള ഒബ്ജക്റ്റിൻ്റെ ലളിതമായ സൃഷ്ടി',
        },
        {
          claim_name: 'CLM-001809',
          claim_statement: 'Test Back Translator',
        },
        {
          claim_name: 'CLM-001818',
          claim_statement:
            'Simple Creation of object with Translations of same language',
        },
        {
          claim_name: 'CLM-001780',
          claim_statement: 'Simple Creation of object with English-English',
        },
        {
          claim_name: 'CLM-001781',
          claim_statement: 'Vim2',
        },
        {
          claim_name: 'CLM-001778',
          claim_statement: 'This is good product',
        },
        {
          claim_name: 'CLM-001779',
          claim_statement: 'Simple Creation of object with no Translations',
        },
        {
          claim_name: 'CLM-001776',
          claim_statement: 'Testing Translated Qualifiersss',
        },
        {
          claim_name: 'CLM-001777',
          claim_statement:
            'ഇംഗ്ലീഷ് ഇതര പ്രസ്താവനയുള്ള ഒബ്ജക്റ്റിൻ്റെ ലളിതമായ സൃഷ്ടി',
        },
        {
          claim_name: 'CLM-001775',
          claim_statement: 'Test Back Translator',
        },
        {
          claim_name: 'CLM-001784',
          claim_statement:
            'Simple Creation of object with Translations of same language',
        },
        {
          claim_name: 'CLM-002443',
          claim_statement: 'fresh & sensitive dyc-free 66 LOADS',
        },
        {
          claim_name: 'CLM-002441',
          claim_statement: 'Gentle on Skin',
        },
        {
          claim_name: 'CLM-002442',
          claim_statement: 'Fresh® Scent',
        },
        {
          claim_name: 'CLM-002446',
          claim_statement: 'Clean,',
        },
        {
          claim_name: 'CLM-003053',
          claim_statement:
            'biodegradable pouch makes these premeasured packs super convenient, without any mess or waste',
        },
        {
          claim_name: 'CLM-003054',
          claim_statement:
            'How to use: Coat hair with liberal amount of shampoo. Gently massage the scalp and roots into rich lather. Rinse Thoroughly. Finish with TRESemmÃ© SILKY & SMOOTH conditioner for locked in hydrated smoothness.',
        },
        {
          claim_name: 'CLM-003052',
          claim_statement:
            'TRESemmÃ© COLOR REVITALISE System penetrates dyed strands to replenish moisture and seal in color for up to 8 weeks vibrancy, ready to take on any style.',
        },
        {
          claim_name: 'CLM-003048',
          claim_statement:
            'How to use: Coat hair with liberal amount of shampoo. Gently massage the scalp and roots into rich lather. Rinse Thoroughly. Finish with TRESemmÃ© RICH MOISTURE conditioner for rich nourishing care.',
        },
        {
          claim_name: 'CLM-003056',
          claim_statement: 'Dermatologist Tested',
        },
        {
          claim_name: 'CLM-003057',
          claim_statement: 'Pro Collection',
        },
        {
          claim_name: 'CLM-003055',
          claim_statement: 'Eliminates visible and invisible dirt',
        },
        {
          claim_name: 'CLM-003082',
          claim_statement:
            'biodegradable pouch makes these premeasured packs super convenient, without any mess or waste',
        },
        {
          claim_name: 'CLM-003083',
          claim_statement:
            'How to use: Coat hair with liberal amount of shampoo. Gently massage the scalp and roots into rich lather. Rinse Thoroughly. Finish with TRESemmÃ© SILKY & SMOOTH conditioner for locked in hydrated smoothness.',
        },
        {
          claim_name: 'CLM-003078',
          claim_statement:
            'TRESemmÃ© COLOR REVITALISE System penetrates dyed strands to replenish moisture and seal in color for up to 8 weeks vibrancy, ready to take on any style.',
        },
        {
          claim_name: 'CLM-003069',
          claim_statement:
            'How to use: Coat hair with liberal amount of shampoo. Gently massage the scalp and roots into rich lather. Rinse Thoroughly. Finish with TRESemmÃ© RICH MOISTURE conditioner for rich nourishing care.',
        },
        {
          claim_name: 'CLM-003087',
          claim_statement: 'Dermatologist Tested',
        },
        {
          claim_name: 'CLM-003088',
          claim_statement: 'Pro Collection',
        },
        {
          claim_name: 'CLM-003086',
          claim_statement: 'Eliminates visible and invisible dirt',
        },
        {
          claim_name: 'CLM-002942',
          claim_statement:
            'biodegradable pouch makes these premeasured packs super convenient, without any mess or waste',
        },
        {
          claim_name: 'CLM-002943',
          claim_statement:
            'How to use: Coat hair with liberal amount of shampoo. Gently massage the scalp and roots into rich lather. Rinse Thoroughly. Finish with TRESemmÃ© SILKY & SMOOTH conditioner for locked in hydrated smoothness.',
        },
        {
          claim_name: 'CLM-002938',
          claim_statement:
            'TRESemmÃ© COLOR REVITALISE System penetrates dyed strands to replenish moisture and seal in color for up to 8 weeks vibrancy, ready to take on any style.',
        },
        {
          claim_name: 'CLM-002929',
          claim_statement:
            'How to use: Coat hair with liberal amount of shampoo. Gently massage the scalp and roots into rich lather. Rinse Thoroughly. Finish with TRESemmÃ© RICH MOISTURE conditioner for rich nourishing care.',
        },
        {
          claim_name: 'CLM-002947',
          claim_statement: 'Dermatologist Tested',
        },
        {
          claim_name: 'CLM-002948',
          claim_statement: 'Pro Collection',
        },
        {
          claim_name: 'CLM-002946',
          claim_statement: 'Eliminates visible and invisible dirt',
        },
        {
          claim_name: 'CLM-003112',
          claim_statement:
            'biodegradable pouch makes these premeasured packs super convenient, without any mess or waste',
        },
        {
          claim_name: 'CLM-003113',
          claim_statement:
            'How to use: Coat hair with liberal amount of shampoo. Gently massage the scalp and roots into rich lather. Rinse Thoroughly. Finish with TRESemmÃ© SILKY & SMOOTH conditioner for locked in hydrated smoothness.',
        },
        {
          claim_name: 'CLM-003108',
          claim_statement:
            'TRESemmÃ© COLOR REVITALISE System penetrates dyed strands to replenish moisture and seal in color for up to 8 weeks vibrancy, ready to take on any style.',
        },
        {
          claim_name: 'CLM-003101',
          claim_statement:
            'How to use: Coat hair with liberal amount of shampoo. Gently massage the scalp and roots into rich lather. Rinse Thoroughly. Finish with TRESemmÃ© RICH MOISTURE conditioner for rich nourishing care.',
        },
        {
          claim_name: 'CLM-003117',
          claim_statement: 'Dermatologist Tested',
        },
        {
          claim_name: 'CLM-003118',
          claim_statement: 'Pro Collection',
        },
        {
          claim_name: 'CLM-003116',
          claim_statement: 'Eliminates visible and invisible dirt',
        },
        {
          claim_name: 'CLM-003151',
          claim_statement: 'Pro Collection',
        },
        {
          claim_name: 'CLM-003149',
          claim_statement: 'Eliminates visible and invisible dirt',
        },
        {
          claim_name: 'CLM-003178',
          claim_statement:
            'biodegradable pouch makes these premeasured packs super convenient, without any mess or waste',
        },
        {
          claim_name: 'CLM-003179',
          claim_statement:
            'How to use: Coat hair with liberal amount of shampoo. Gently massage the scalp and roots into rich lather. Rinse Thoroughly. Finish with TRESemmÃ© SILKY & SMOOTH conditioner for locked in hydrated smoothness.',
        },
        {
          claim_name: 'CLM-003174',
          claim_statement:
            'TRESemmÃ© COLOR REVITALISE System penetrates dyed strands to replenish moisture and seal in color for up to 8 weeks vibrancy, ready to take on any style.',
        },
        {
          claim_name: 'CLM-003165',
          claim_statement:
            'How to use: Coat hair with liberal amount of shampoo. Gently massage the scalp and roots into rich lather. Rinse Thoroughly. Finish with TRESemmÃ© RICH MOISTURE conditioner for rich nourishing care.',
        },
        {
          claim_name: 'CLM-003183',
          claim_statement: 'Dermatologist Tested',
        },
        {
          claim_name: 'CLM-003184',
          claim_statement: 'Pro Collection',
        },
        {
          claim_name: 'CLM-003182',
          claim_statement: 'Eliminates visible and invisible dirt',
        },
        {
          claim_name: 'CLM-003295',
          claim_statement: 'Clean,',
        },
        {
          claim_name: 'CLM-003384',
          claim_statement: 'Now you can have it all',
        },
        {
          claim_name: 'CLM-003344',
          claim_statement: 'BREEZE',
        },
        {
          claim_name: 'CLM-003348',
          claim_statement: 'BREEZE LIQUID DETERGENT',
        },
        {
          claim_name: 'CLM-003346',
          claim_statement: 'REMOVES STAINS 2X MORE POWER THAN POWDER',
        },
        {
          claim_name: 'CLM-003381',
          claim_statement: 'Test1',
        },
        {
          claim_name: 'CLM-003379',
          claim_statement: 'Test3',
        },
        {
          claim_name: 'CLM-003375',
          claim_statement: 'Fresh® Scent',
        },
        {
          claim_name: 'CLM-003396',
          claim_statement: 'Gentle on Skin',
        },
        {
          claim_name: 'CLM-003394',
          claim_statement: 'Clean,',
        },
        {
          claim_name: 'CLM-003321',
          claim_statement: 'WITH LONG LASTING FRAGRANCE',
        },
        {
          claim_name: 'CLM-003349',
          claim_statement: 'Test2',
        },
        {
          claim_name: 'CLM-003347',
          claim_statement: 'Surf excel MATIC',
        },
        {
          claim_name: 'CLM-003345',
          claim_statement: 'Test Ira Veeva Save',
        },
        {
          claim_name: 'CLM-003362',
          claim_statement: 'NEW FRONT LOAD',
        },
        {
          claim_name: 'CLM-003361',
          claim_statement: 'Sample',
        },
        {
          claim_name: 'CLM-003360',
          claim_statement: 'Test',
        },
        {
          claim_name: 'CLM-003358',
          claim_statement: 'Silk Touch',
        },
        {
          claim_name: 'CLM-003409',
          claim_statement: 'സർഫ് എക്സൽ MATIC',
        },
        {
          claim_name: 'CLM-003324',
          claim_statement: 'Ar 200',
        },
        {
          claim_name: 'CLM-003322',
          claim_statement:
            'The April Fresh® you love in a Limited Edition bottle.',
        },
        {
          claim_name: 'CLM-003341',
          claim_statement: 'Test Text 30',
        },
        {
          claim_name: 'CLM-003342',
          claim_statement: 'This is good product',
        },
        {
          claim_name: 'CLM-003301',
          claim_statement: 'Freanch Statement1',
        },
        {
          claim_name: 'CLM-003303',
          claim_statement: 'Tese 3',
        },
        {
          claim_name: 'CLM-003302',
          claim_statement: 'Test Text 20',
        },
        {
          claim_name: 'CLM-003304',
          claim_statement: 'This is for testing Purpose',
        },
        {
          claim_name: 'CLM-003364',
          claim_statement: 'Keep shining',
        },
        {
          claim_name: 'CLM-003365',
          claim_statement: 'Bright like new*',
        },
        {
          claim_name: 'CLM-003333',
          claim_statement: 'Bright like new',
        },
        {
          claim_name: 'CLM-003388',
          claim_statement:
            'biodegradable pouch makes these premeasured packs super convenient, without any mess or waste',
        },
        {
          claim_name: 'CLM-003398',
          claim_statement:
            'How to use: Coat hair with liberal amount of shampoo. Gently massage the scalp and roots into rich lather. Rinse Thoroughly. Finish with TRESemmÃ© SILKY & SMOOTH conditioner for locked in hydrated smoothness.',
        },
        {
          claim_name: 'CLM-003331',
          claim_statement:
            'TRESemmÃ© COLOR REVITALISE System penetrates dyed strands to replenish moisture and seal in color for up to 8 weeks vibrancy, ready to take on any style.',
        },
        {
          claim_name: 'CLM-003317',
          claim_statement:
            'How to use: Coat hair with liberal amount of shampoo. Gently massage the scalp and roots into rich lather. Rinse Thoroughly. Finish with TRESemmÃ© RICH MOISTURE conditioner for rich nourishing care.',
        },
        {
          claim_name: 'CLM-003400',
          claim_statement: 'Dermatologist Tested',
        },
        {
          claim_name: 'CLM-003399',
          claim_statement: 'Pro Collection',
        },
        {
          claim_name: 'CLM-003397',
          claim_statement: 'Eliminates visible and invisible dirt',
        },
        {
          claim_name: 'CLM-003442',
          claim_statement: 'Now you can have it all',
        },
        {
          claim_name: 'CLM-003504',
          claim_statement: 'BREEZE',
        },
        {
          claim_name: 'CLM-003500',
          claim_statement: 'BREEZE LIQUID DETERGENT',
        },
        {
          claim_name: 'CLM-003502',
          claim_statement: 'REMOVES STAINS 2X MORE POWER THAN POWDER',
        },
        {
          claim_name: 'CLM-003445',
          claim_statement: 'Test1',
        },
        {
          claim_name: 'CLM-003498',
          claim_statement: 'Test3',
        },
        {
          claim_name: 'CLM-003492',
          claim_statement: 'Fresh® Scent',
        },
        {
          claim_name: 'CLM-003461',
          claim_statement: 'Gentle on Skin',
        },
        {
          claim_name: 'CLM-003463',
          claim_statement: 'Clean,',
        },
        {
          claim_name: 'CLM-003417',
          claim_statement: 'WITH LONG LASTING FRAGRANCE',
        },
        {
          claim_name: 'CLM-003518',
          claim_statement: 'Test2',
        },
        {
          claim_name: 'CLM-003501',
          claim_statement: 'Surf excel MATIC',
        },
        {
          claim_name: 'CLM-003503',
          claim_statement: 'Test Ira Veeva Save',
        },
        {
          claim_name: 'CLM-003482',
          claim_statement: 'NEW FRONT LOAD',
        },
        {
          claim_name: 'CLM-003483',
          claim_statement: 'Sample',
        },
        {
          claim_name: 'CLM-003484',
          claim_statement: 'Test',
        },
        {
          claim_name: 'CLM-003510',
          claim_statement: 'Silk Touch',
        },
        {
          claim_name: 'CLM-003490',
          claim_statement: 'സർഫ് എക്സൽ MATIC',
        },
        {
          claim_name: 'CLM-003416',
          claim_statement:
            'The April Fresh® you love in a Limited Edition bottle.',
        },
        {
          claim_name: 'CLM-003507',
          claim_statement: 'Test Text 30',
        },
        {
          claim_name: 'CLM-003506',
          claim_statement: 'This is good product',
        },
        {
          claim_name: 'CLM-003437',
          claim_statement: 'Freanch Statement1',
        },
        {
          claim_name: 'CLM-003435',
          claim_statement: 'Tese 3',
        },
        {
          claim_name: 'CLM-003436',
          claim_statement: 'Test Text 20',
        },
        {
          claim_name: 'CLM-003434',
          claim_statement: 'This is for testing Purpose',
        },
        {
          claim_name: 'CLM-003480',
          claim_statement: 'Keep shining',
        },
        {
          claim_name: 'CLM-003479',
          claim_statement: 'Bright like new*',
        },
        {
          claim_name: 'CLM-003425',
          claim_statement: 'Bright like new',
        },
        {
          claim_name: 'CLM-003449',
          claim_statement:
            'biodegradable pouch makes these premeasured packs super convenient, without any mess or waste',
        },
        {
          claim_name: 'CLM-003478',
          claim_statement:
            'How to use: Coat hair with liberal amount of shampoo. Gently massage the scalp and roots into rich lather. Rinse Thoroughly. Finish with TRESemmÃ© SILKY & SMOOTH conditioner for locked in hydrated smoothness.',
        },
        {
          claim_name: 'CLM-003427',
          claim_statement:
            'TRESemmÃ© COLOR REVITALISE System penetrates dyed strands to replenish moisture and seal in color for up to 8 weeks vibrancy, ready to take on any style.',
        },
        {
          claim_name: 'CLM-003451',
          claim_statement:
            'How to use: Coat hair with liberal amount of shampoo. Gently massage the scalp and roots into rich lather. Rinse Thoroughly. Finish with TRESemmÃ© RICH MOISTURE conditioner for rich nourishing care.',
        },
        {
          claim_name: 'CLM-003474',
          claim_statement: 'Dermatologist Tested',
        },
        {
          claim_name: 'CLM-003476',
          claim_statement: 'Pro Collection',
        },
        {
          claim_name: 'CLM-003459',
          claim_statement: 'Eliminates visible and invisible dirt',
        },
        {
          claim_name: 'CLM-003579',
          claim_statement: 'Now you can have it all',
        },
        {
          claim_name: 'CLM-003531',
          claim_statement: 'BREEZE LIQUID DETERGENT',
        },
        {
          claim_name: 'CLM-003533',
          claim_statement: 'REMOVES STAINS 2X MORE POWER THAN POWDER',
        },
        {
          claim_name: 'CLM-003582',
          claim_statement: 'Test1',
        },
        {
          claim_name: 'CLM-003539',
          claim_statement: 'Test3',
        },
        {
          claim_name: 'CLM-003522',
          claim_statement: 'Fresh® Scent',
        },
        {
          claim_name: 'CLM-003549',
          claim_statement: 'Gentle on Skin',
        },
        {
          claim_name: 'CLM-003551',
          claim_statement: 'Clean,',
        },
        {
          claim_name: 'CLM-003546',
          claim_statement: 'WITH LONG LASTING FRAGRANCE',
        },
        {
          claim_name: 'CLM-003575',
          claim_statement: 'Test2',
        },
        {
          claim_name: 'CLM-003532',
          claim_statement: 'Surf excel MATIC',
        },
        {
          claim_name: 'CLM-003534',
          claim_statement: 'Test Ira Veeva Save',
        },
        {
          claim_name: 'CLM-003558',
          claim_statement: 'NEW FRONT LOAD',
        },
        {
          claim_name: 'CLM-003524',
          claim_statement: 'Sample',
        },
        {
          claim_name: 'CLM-003525',
          claim_statement: 'Test',
        },
        {
          claim_name: 'CLM-003565',
          claim_statement: 'Silk Touch',
        },
        {
          claim_name: 'CLM-003520',
          claim_statement: 'സർഫ് എക്സൽ MATIC',
        },
        {
          claim_name: 'CLM-003545',
          claim_statement:
            'The April Fresh® you love in a Limited Edition bottle.',
        },
        {
          claim_name: 'CLM-003600',
          claim_statement: 'Test Text 30',
        },
        {
          claim_name: 'CLM-003599',
          claim_statement: 'This is good product',
        },
        {
          claim_name: 'CLM-003620',
          claim_statement: 'Freanch Statement1',
        },
        {
          claim_name: 'CLM-003618',
          claim_statement: 'Tese 3',
        },
        {
          claim_name: 'CLM-003619',
          claim_statement: 'Test Text 20',
        },
        {
          claim_name: 'CLM-003617',
          claim_statement: 'This is for testing Purpose',
        },
        {
          claim_name: 'CLM-003556',
          claim_statement: 'Keep shining',
        },
        {
          claim_name: 'CLM-003568',
          claim_statement: 'Bright like new*',
        },
        {
          claim_name: 'CLM-003608',
          claim_statement: 'Bright like new',
        },
        {
          claim_name: 'CLM-003566',
          claim_statement:
            'How to use: Coat hair with liberal amount of shampoo. Gently massage the scalp and roots into rich lather. Rinse Thoroughly. Finish with TRESemmÃ© SILKY & SMOOTH conditioner for locked in hydrated smoothness.',
        },
        {
          claim_name: 'CLM-003610',
          claim_statement:
            'TRESemmÃ© COLOR REVITALISE System penetrates dyed strands to replenish moisture and seal in color for up to 8 weeks vibrancy, ready to take on any style.',
        },
        {
          claim_name: 'CLM-003589',
          claim_statement:
            'How to use: Coat hair with liberal amount of shampoo. Gently massage the scalp and roots into rich lather. Rinse Thoroughly. Finish with TRESemmÃ© RICH MOISTURE conditioner for rich nourishing care.',
        },
        {
          claim_name: 'CLM-003561',
          claim_statement: 'Dermatologist Tested',
        },
        {
          claim_name: 'CLM-003563',
          claim_statement: 'Pro Collection',
        },
        {
          claim_name: 'CLM-003597',
          claim_statement: 'Eliminates visible and invisible dirt',
        },
        {
          claim_name: 'CLM-002191',
          claim_statement:
            '*Vs. UK market leader in bathroom sprays ** Tested on most common kitchen surfaces',
        },
        {
          claim_name: 'CLM-004154',
          claim_statement:
            '*Vs. UK market leader in bathroom sprays ** Tested on most common kitchen surfaces',
        },
        {
          claim_name: 'CLM-004203',
          claim_statement: 'fresh & sensitive dyc-free 66 LOADS',
        },
        {
          claim_name: 'CLM-004207',
          claim_statement: 'Clean,',
        },
        {
          claim_name: 'CLM-004401',
          claim_statement: 'Now you can have it all',
        },
        {
          claim_name: 'CLM-004347',
          claim_statement: 'BREEZE LIQUID DETERGENT',
        },
        {
          claim_name: 'CLM-004349',
          claim_statement: 'REMOVES STAINS 2X MORE POWER THAN POWDER',
        },
        {
          claim_name: 'CLM-004358',
          claim_statement: 'Test1',
        },
        {
          claim_name: 'CLM-004354',
          claim_statement: 'Test3',
        },
        {
          claim_name: 'CLM-004338',
          claim_statement: 'Fresh® Scent',
        },
        {
          claim_name: 'CLM-004419',
          claim_statement: 'Gentle on Skin',
        },
        {
          claim_name: 'CLM-004421',
          claim_statement: 'Clean,',
        },
        {
          claim_name: 'CLM-004416',
          claim_statement: 'WITH LONG LASTING FRAGRANCE',
        },
        {
          claim_name: 'CLM-004395',
          claim_statement: 'Test2',
        },
        {
          claim_name: 'CLM-004348',
          claim_statement: 'Surf excel MATIC',
        },
        {
          claim_name: 'CLM-004350',
          claim_statement: 'Test Ira Veeva Save',
        },
        {
          claim_name: 'CLM-004428',
          claim_statement: 'NEW FRONT LOAD',
        },
        {
          claim_name: 'CLM-004340',
          claim_statement: 'Sample',
        },
        {
          claim_name: 'CLM-004341',
          claim_statement: 'Test',
        },
        {
          claim_name: 'CLM-004385',
          claim_statement: 'Silk Touch',
        },
        {
          claim_name: 'CLM-004335',
          claim_statement: 'സർഫ് എക്സൽ MATIC',
        },
        {
          claim_name: 'CLM-004415',
          claim_statement:
            'The April Fresh® you love in a Limited Edition bottle.',
        },
        {
          claim_name: 'CLM-004368',
          claim_statement: 'Test Text 30',
        },
        {
          claim_name: 'CLM-004378',
          claim_statement: 'This is good product',
        },
        {
          claim_name: 'CLM-004363',
          claim_statement: 'Freanch Statement1',
        },
        {
          claim_name: 'CLM-004408',
          claim_statement: 'Tese 3',
        },
        {
          claim_name: 'CLM-004409',
          claim_statement: 'Test Text 20',
        },
        {
          claim_name: 'CLM-004407',
          claim_statement: 'This is for testing Purpose',
        },
        {
          claim_name: 'CLM-004426',
          claim_statement: 'Keep shining',
        },
        {
          claim_name: 'CLM-004388',
          claim_statement: 'Bright like new*',
        },
        {
          claim_name: 'CLM-004336',
          claim_statement: 'Bright like new',
        },
        {
          claim_name: 'CLM-004386',
          claim_statement:
            'How to use: Coat hair with liberal amount of shampoo. Gently massage the scalp and roots into rich lather. Rinse Thoroughly. Finish with TRESemmÃ© SILKY & SMOOTH conditioner for locked in hydrated smoothness.',
        },
        {
          claim_name: 'CLM-004398',
          claim_statement:
            'TRESemmÃ© COLOR REVITALISE System penetrates dyed strands to replenish moisture and seal in color for up to 8 weeks vibrancy, ready to take on any style.',
        },
        {
          claim_name: 'CLM-004366',
          claim_statement:
            'How to use: Coat hair with liberal amount of shampoo. Gently massage the scalp and roots into rich lather. Rinse Thoroughly. Finish with TRESemmÃ© RICH MOISTURE conditioner for rich nourishing care.',
        },
        {
          claim_name: 'CLM-004381',
          claim_statement: 'Dermatologist Tested',
        },
        {
          claim_name: 'CLM-004383',
          claim_statement: 'Pro Collection',
        },
        {
          claim_name: 'CLM-004376',
          claim_statement: 'Eliminates visible and invisible dirt',
        },
        {
          claim_name: 'CLM-004707',
          claim_statement: 'Beautifully clean & shiny kichen',
        },
        {
          claim_name: 'CLM-004669',
          claim_statement: 'Test',
        },
        {
          claim_name: 'CLM-004658',
          claim_statement: 'Sample',
        },
        {
          claim_name: 'CLM-004653',
          claim_statement: '100% oil and grease stain removal',
        },
        {
          claim_name: 'CLM-004687',
          claim_statement: 'Example',
        },
        {
          claim_name: 'CLM-004688',
          claim_statement: '100% unbeatable* streak-free shine',
        },
        {
          claim_name: 'CLM-004715',
          claim_statement: '100% unbeatable* streak-free shine',
        },
        {
          claim_name: 'CLM-004711',
          claim_statement: 'Test2',
        },
        {
          claim_name: 'CLM-004710',
          claim_statement: 'Clean  Fresh Scent',
        },
        {
          claim_name: 'CLM-004680',
          claim_statement: 'Sanitizes and fights bad odor',
        },
        {
          claim_name: 'CLM-004679',
          claim_statement: 'This is a test claim 1',
        },
        {
          claim_name: 'CLM-004677',
          claim_statement: 'This is a test claim 2',
        },
        {
          claim_name: 'CLM-004676',
          claim_statement: 'This is a test claim 3',
        },
        {
          claim_name: 'CLM-004661',
          claim_statement: 'Rın',
        },
        {
          claim_name: 'CLM-004660',
          claim_statement: 'BRIGHT LIRE NEW',
        },
        {
          claim_name: 'CLM-004659',
          claim_statement: 'Keep shining',
        },
        {
          claim_name: 'CLM-004656',
          claim_statement: 'Test1',
        },
        {
          claim_name: 'CLM-004654',
          claim_statement: 'Test3',
        },
        {
          claim_name: 'CLM-004670',
          claim_statement: 'Machine and Colour care',
        },
        {
          claim_name: 'CLM-004671',
          claim_statement: 'This is a test claim 4',
        },
        {
          claim_name: 'CLM-004673',
          claim_statement: 'This is a test claim 5',
        },
        {
          claim_name: 'CLM-004674',
          claim_statement: 'This is a test claim 6',
        },
        {
          claim_name: 'CLM-004684',
          claim_statement: 'Bright like new*',
        },
        {
          claim_name: 'CLM-004686',
          claim_statement: 'Stainlifters test 3',
        },
        {
          claim_name: 'CLM-004651',
          claim_statement: 'Keep shining',
        },
        {
          claim_name: 'CLM-004652',
          claim_statement: 'Rin',
        },
        {
          claim_name: 'CLM-004666',
          claim_statement: 'Test3',
        },
        {
          claim_name: 'CLM-004668',
          claim_statement: 'Test1',
        },
        {
          claim_name: 'CLM-004664',
          claim_statement: 'Disclaimer to be incorporated',
        },
        {
          claim_name: 'CLM-004663',
          claim_statement: 'Test10',
        },
        {
          claim_name: 'CLM-004665',
          claim_statement: 'Example',
        },
        {
          claim_name: 'CLM-004667',
          claim_statement: 'Test2',
        },
        {
          claim_name: 'CLM-004649',
          claim_statement: 'yest Cl;aim 2',
        },
        {
          claim_name: 'CLM-004705',
          claim_statement: 'daag achhe hain',
        },
        {
          claim_name: 'CLM-004703',
          claim_statement:
            'SURF EXCEL LIQUID Removes stain 2X better than powders',
        },
        {
          claim_name: 'CLM-004716',
          claim_statement: 'Test5',
        },
        {
          claim_name: 'CLM-004650',
          claim_statement: 'Test Claim 1',
        },
        {
          claim_name: 'CLM-004706',
          claim_statement:
            'Try the Clean  Fresh Scent that Sensitive skin has been waiting for',
        },
        {
          claim_name: 'CLM-004701',
          claim_statement:
            'New all® fresh & sensitive™ has a clean  fresh hypoallergenic scent  so its gentle on skin  but tough on stains. Now you can have it all.',
        },
        {
          claim_name: 'CLM-004718',
          claim_statement: 'NEW',
        },
        {
          claim_name: 'CLM-004662',
          claim_statement: 'lavagemperfeita',
        },
        {
          claim_name: 'CLM-004712',
          claim_statement: 'Claim 4',
        },
        {
          claim_name: 'CLM-004713',
          claim_statement: 'Claim 2',
        },
        {
          claim_name: 'CLM-004714',
          claim_statement:
            'This is a claim This is a claim This is a claim This is a claim This is a claim This is a claim This is a claim This is a claim This is a claim This is a claim This is a claim',
        },
        {
          claim_name: 'CLM-004692',
          claim_statement: 'Claim 3',
        },
        {
          claim_name: 'CLM-004882',
          claim_statement: 'Dirt free scalp',
        },
        {
          claim_name: 'CLM-004785',
          claim_statement: 'Surf Surf surfecel gdm',
        },
      ],
      related_products: [
        'Surf Excel Matic Std Liquid test1 To Copy 3',
        'TRESemme Conditioner TRESemmé Silky & Smooth Conditioner',
        'Dove Shower Gel / Body Wash Premium',
        'All Concentrated Washing Liquid Fresh & Sensitive',
        "Ben & Jerry's Ice Cream Pint Test",
        'Arisco Universal Seasoning Carne',
        'Comfort Concentrated Washing Powder XYZ Test',
        'Brilhante Washing Powder Brilhante Cuidado Total',
        'TRESemme Shampoo Ultra To Copy Test 2',
        'Dove Conditioner new',
        'TRESemme Shampoo TRESemmé Rich Moisture Shampoo',
        'Dove Skin Cleansing Bar CR411',
        'TRESemme Shampoo TRESemme Rich Moisture Shampoo order Variant Create 1',
        'Dove Mask new',
        'TRESemme Shampoo Daily moisture',
        'Dove Antiperspirant Aerosol Spray Advanced Care Name Update 3 TRESemmé 24HR Volume Shampoo',
        'TRESemme Shampoo TRESemmé Silky & Smooth Shampoo 2',
        'Dove Shower Gel / Body Wash Premium Original',
        'Dove Shower Gel / Body Wash Premium Fresh',
        'Arisco Vinegar To Variant 3 Variant 1',
        'TRESemme Shampoo TRESemme Rich Moisture Shampoo order To Copy Demo 2.',
        'Vaseline Body Lotion Intensive Care / Soothing Hydration',
        'Dove Antiperspirant Aerosol Spray Advanced Care Name Update 3 TRESemmé Color Revitalise Shampoo',
        'Dove Antiperspirant Aerosol Spray Advanced Care',
        'Surf Excel Washing Powder Surf Excel Easy Wash detergent powder',
        'Surf Excel Matic Std Liquid Test',
        'Dove Antiperspirant Aerosol Spray Advanced Care Caring Coconut 2',
        'Test Brand Test Format Test variant',
        'TRESemme Conditioner smooth TRESemmé Rich Moisture Conditioner',
        'TRESemme Hair Lotion Test',
        'Dove Skin Cleansing Bar CR411 01',
        'Dove Deo Aero AP Spray',
        'Arisco Bouillon Cube Test 12',
        '3D Multiusos Abrasive Powder 3D FLORAL',
        'Comfort Rinse Cond Std Liquid Wash 10',
        'Dove Antiperspirant Aerosol Spray Advanced Care Name Update 3 Omo Lavagem Perfeita 900ml',
        'Brilhante Washing Powder Brilhante Limpeza Total Pó',
        'Arisco Vinegar To Copy Variant 6 To COpy Job',
        'Arisco Bouillon Cube Test 3',
        'Dove Antiperspirant Aerosol Spray Advanced Care Name Update 3 TRESemmé Keratin Repair Shampoo',
        'Dove Antiperspirant Aerosol Spray Advanced Care Name Update 3 Omo Lavagem Perfeita 3L',
        'TRESemme Non Aerosol Finishing Spray bottle',
        'Dove Antiperspirant Aerosol Spray Advanced Care Name Update 3 Awaken',
        'Omo Concentrated Washing Capsules Test',
        'Sunlight Plus Clean & Care',
        'Dove Deo Aero AP Spray dgdfg',
        'Dove Oil lotion',
        'Comfort Concentrated Washing Powder Test 431',
        'TRESemme Shampoo pack.',
        'Dove Deo Aero AP Advanced Care To Copy test 3',
        'Dove Shampoo Daily Moisture',
        'TRESemme Shampoo TRESemme Rich Moisture Shampoo order',
      ],
      related_projects: ['Check_Data\nCopy of Check_Data'],
      'substantiation__vr.description__v': 'Beauty Products',
      'substantiation__vr.name__v': 'SUB-000005',
    },
  ],
};

const MOCK_JSON_WITHGEO = {
  data: [
    {
      document_id: '3501',
      document_link:
        'https://sb-unilever-claims.veevavault.com/ui/#doc_info/3501/2/0',
      'local_adaptation__cr.related_projects__c': 'SPARCi (EEOC) project 1',
      related_localadaptations: [
        {
          la_name: 'CLM-001290.IN',
          la_statement: 'NEW',
        },
        {
          la_name: 'CLM-001269.IN',
          la_statement: 'BRIGHT LIRE NEW',
        },
        {
          la_name: 'CLM-001220.IN',
          la_statement: '100% unbeatable* streak-free shine',
        },
        {
          la_name: 'CLM-001009.IN',
          la_statement: '100% unbeatable* streak-free shine',
        },
        {
          la_name: 'CLM-001010.IN',
          la_statement: '100% oil and grease stain removal',
        },
        {
          la_name: 'CLM-001023.IN',
          la_statement: 'Surf excel MATIC',
        },
        {
          la_name: 'CLM-001028.IN',
          la_statement: 'Test2',
        },
        {
          la_name: 'CLM-001030.IN',
          la_statement: 'நீடித்த நறுமணத்துடன்',
        },
        {
          la_name: 'CLM-001024.IN',
          la_statement: '3X TOUGH STAINS',
        },
        {
          la_name: 'CLM-001034.IN',
          la_statement: 'സർഫ് എക്സൽ MATIC',
        },
        {
          la_name: 'CLM-001033.IN',
          la_statement: 'Silk Touch',
        },
        {
          la_name: 'CLM-001045.IN',
          la_statement: 'Machine and Colour care',
        },
        {
          la_name: 'CLM-001046.IN',
          la_statement: 'This is a test claim 1',
        },
        {
          la_name: 'CLM-001047.IN',
          la_statement: 'This is a test claim 2',
        },
        {
          la_name: 'CLM-001048.IN',
          la_statement: 'This is a test claim 3',
        },
        {
          la_name: 'CLM-001050.IN',
          la_statement: 'This is a test claim 5',
        },
        {
          la_name: 'CLM-001063.IN',
          la_statement: 'Test1',
        },
        {
          la_name: 'CLM-001026.IN',
          la_statement: 'ಪರೀಕ್ಷೆ2',
        },
        {
          la_name: 'CLM-001067.IN',
          la_statement: 'This is LA Testing to Save Translations',
        },
        {
          la_name: 'CLM-001037.IN',
          la_statement: 'Ar 200',
        },
        {
          la_name: 'CLM-001038.IN',
          la_statement:
            'The April Fresh® you love in a Limited Edition bottle.',
        },
        {
          la_name: 'CLM-001039.IN',
          la_statement: '*Disclaimer to be incorporated',
        },
        {
          la_name: 'CLM-001040.IN',
          la_statement: 'Bright like new',
        },
        {
          la_name: 'CLM-001041.IN',
          la_statement: 'Keep shining',
        },
        {
          la_name: 'CLM-001044.IN',
          la_statement: 'Sanitizes and fights bad odor',
        },
        {
          la_name: 'CLM-001049.IN',
          la_statement: 'This is a test claim 4',
        },
        {
          la_name: 'CLM-001051.IN',
          la_statement: 'This is a test claim 6',
        },
        {
          la_name: 'CLM-001064.IN',
          la_statement: 'Test3',
        },
        {
          la_name: 'CLM-001065.IN',
          la_statement: 'Stainlifters test 3',
        },
        {
          la_name: 'CLM-001066.IN',
          la_statement: 'This is LA Testing to Save Translations',
        },
        {
          la_name: 'CLM-001162.IN',
          la_statement: 'ఇప్పుడు మీరు అన్నీ పొందవచ్చు.',
        },
        {
          la_name: 'CLM-001195.IN',
          la_statement:
            'Simple Creation of object with Translations of same language',
        },
        {
          la_name: 'CLM-001199.IN',
          la_statement: 'ఇది తెలుగులో ఒక ప్రకటన.',
        },
        {
          la_name: 'CLM-001204.IN',
          la_statement: 'தேவில் LA சோதனை',
        },
        {
          la_name: 'CLM-001209.IN',
          la_statement: 'Simple Creation of object with English-English',
        },
        {
          la_name: 'CLM-001212.IN',
          la_statement: 'ஃப்ரீன்ச் கூற்று1',
        },
        {
          la_name: 'CLM-001213.IN',
          la_statement: 'விம்2',
        },
        {
          la_name: 'CLM-001214.IN',
          la_statement: 'Testing Save Veeva API',
        },
        {
          la_name: 'CLM-001215.IN',
          la_statement: 'స్టెయిన్ లిఫ్టర్స్ టెస్ట్ 2',
        },
        {
          la_name: 'CLM-001218.IN',
          la_statement: 'Kitchen Cleaner Benefits',
        },
        {
          la_name: 'CLM-001165.IN',
          la_statement:
            'ക്രോസ് ലാംഗ്വേജിൽ ഒബ്‌ജക്‌റ്റുകൾ സൃഷ്‌ടിക്കുന്നത് പരിശോധിക്കുന്നു',
        },
        {
          la_name: 'CLM-001193.IN',
          la_statement: 'Simple Creation of object with no Translations',
        },
        {
          la_name: 'CLM-001194.IN',
          la_statement: 'ಅನುವಾದಗಳೊಂದಿಗೆ ವಸ್ತುವಿನ ಸರಳ ರಚನೆ',
        },
        {
          la_name: 'CLM-001196.IN',
          la_statement: 'Test Back Translator',
        },
        {
          la_name: 'CLM-001197.IN',
          la_statement:
            'ഇംഗ്ലീഷ് ഇതര പ്രസ്താവനയുള്ള ഒബ്ജക്റ്റിൻ്റെ ലളിതമായ സൃഷ്ടി',
        },
        {
          la_name: 'CLM-001200.IN',
          la_statement: 'புதிய படைப்பு 1000',
        },
        {
          la_name: 'CLM-001205.IN',
          la_statement: 'This is a child creation in English',
        },
        {
          la_name: 'CLM-001210.IN',
          la_statement: 'Testing 6th Scenario',
        },
        {
          la_name: 'CLM-001217.IN',
          la_statement:
            '*Vs. UK market leader in bathroom sprays ** Tested on most common kitchen surfaces',
        },
        {
          la_name: 'CLM-001219.IN',
          la_statement: 'Beautifully clean & shiny kichen',
        },
        {
          la_name: 'CLM-001221.IN',
          la_statement: '100% oil and grease stain removal',
        },
        {
          la_name: 'CLM-001226.IN',
          la_statement: 'ಇಂಗ್ಲಿಷ್-ಇಂಗ್ಲಿಷ್ ನೊಂದಿಗೆ ಆಬ್ಜೆಕ್ಟ್ ನ ಸರಳ ರಚನೆ',
        },
        {
          la_name: 'CLM-001235.IN',
          la_statement: 'Vim Liquid',
        },
        {
          la_name: 'CLM-001236.IN',
          la_statement: 'Concentrated Cal',
        },
        {
          la_name: 'CLM-001227.IN',
          la_statement: 'This is a child creation in English',
        },
        {
          la_name: 'CLM-001243.IN',
          la_statement: 'Disclaimer to be incorporated',
        },
        {
          la_name: 'CLM-001247.IN',
          la_statement: 'Test3',
        },
        {
          la_name: 'CLM-001250.IN',
          la_statement: '100% unbeatable* streak-free shine',
        },
        {
          la_name: 'CLM-001251.IN',
          la_statement: 'lavagemperfeita',
        },
        {
          la_name: 'CLM-001255.IN',
          la_statement: 'CONTEM 800 g LAVA ROUPAS EM PÓ',
        },
        {
          la_name: 'CLM-001257.IN',
          la_statement:
            'ATIVO CONCENTRADO TECNOLOGIA QUE CUIDA DO MEIO AMBIENTE',
        },
        {
          la_name: 'CLM-001262.IN',
          la_statement: 'Bright like new*',
        },
        {
          la_name: 'CLM-001268.IN',
          la_statement: '100% oil and grease stain removal',
        },
        {
          la_name: 'CLM-001266.IN',
          la_statement:
            '*Vs. UK market leader in bathroom sprays ** Tested on most common kitchen surfaces',
        },
        {
          la_name: 'CLM-001273.IN',
          la_statement: 'Keep shining',
        },
        {
          la_name: 'CLM-001276.IN',
          la_statement: 'Test2',
        },
        {
          la_name: 'CLM-001279.IN',
          la_statement: 'Test1',
        },
        {
          la_name: 'CLM-001277.IN',
          la_statement: 'Test4',
        },
        {
          la_name: 'CLM-001284.IN',
          la_statement: 'Testing on Dev',
        },
        {
          la_name: 'CLM-001285.IN',
          la_statement: 'Testing',
        },
        {
          la_name: 'CLM-001288.IN',
          la_statement:
            'Try the Clean  Fresh Scent that Sensitive skin has been waiting for',
        },
        {
          la_name: 'CLM-001289.IN',
          la_statement:
            'New all® fresh & sensitive™ has a clean  fresh hypoallergenic scent  so its gentle on skin  but tough on stains. Now you can have it all.',
        },
        {
          la_name: 'CLM-001246.IN',
          la_statement: 'Test1',
        },
        {
          la_name: 'CLM-001365.IN',
          la_statement: 'ಹೊಸ ಬದಲಾವಣೆಗಳನ್ನು ಪರೀಕ್ಷಿಸಲಾಗುತ್ತಿದೆ',
        },
        {
          la_name: 'CLM-001239.IN',
          la_statement: 'Test1',
        },
        {
          la_name: 'CLM-001375.IN',
          la_statement: 'Test3',
        },
        {
          la_name: 'CLM-001381.IN',
          la_statement: 'PLATINUM',
        },
        {
          la_name: 'CLM-001244.IN',
          la_statement: 'Keep shining',
        },
        {
          la_name: 'CLM-001245.IN',
          la_statement: 'Bright like new*',
        },
        {
          la_name: 'CLM-001248.IN',
          la_statement: 'Test2',
        },
        {
          la_name: 'CLM-001252.IN',
          la_statement: 'Imbatível na LIMPEZA cuida do meio ambiente 5 UL',
        },
        {
          la_name: 'CLM-001253.IN',
          la_statement: 'IMBATÍVEL NA LIMPEZA',
        },
        {
          la_name: 'CLM-001254.IN',
          la_statement: 'CUIDA DO MEIO AMBIENTE',
        },
        {
          la_name: 'CLM-001256.IN',
          la_statement: '800g RENDE PÓ ULTRAFINO IGUAL 1 kg NÃO DEIXA RESÍDUOS',
        },
        {
          la_name: 'CLM-001264.IN',
          la_statement: 'Keep shining',
        },
        {
          la_name: 'CLM-001263.IN',
          la_statement: 'Disclaimer to be incorporated.',
        },
        {
          la_name: 'CLM-001265.IN',
          la_statement: 'Beautifully clean & shiny kichen',
        },
        {
          la_name: 'CLM-001267.IN',
          la_statement: 'Kitchen Cleaner Benefits',
        },
        {
          la_name: 'CLM-001274.IN',
          la_statement: 'Bright like new*',
        },
        {
          la_name: 'CLM-001275.IN',
          la_statement: 'Disclaimer to be incorporated.',
        },
        {
          la_name: 'CLM-001278.IN',
          la_statement: 'Test3',
        },
        {
          la_name: 'CLM-001286.IN',
          la_statement: 'Testing1',
        },
        {
          la_name: 'CLM-001287.IN',
          la_statement: 'tws',
        },
        {
          la_name: 'CLM-001291.IN',
          la_statement: 'Text',
        },
        {
          la_name: 'CLM-001292.IN',
          la_statement: 'Test',
        },
        {
          la_name: 'CLM-001364.IN',
          la_statement: 'Testing New Changes',
        },
        {
          la_name: 'CLM-001376.IN',
          la_statement: 'ON SPONGE* AND DISHES^',
        },
        {
          la_name: 'CLM-001377.IN',
          la_statement: 'RHAMN clean TM 00% PLANT-BASED ACTIVE',
        },
        {
          la_name: 'CLM-001380.IN',
          la_statement: '24 HR',
        },
        {
          la_name: 'CLM-001379.IN',
          la_statement:
            'ANTIBACTERIAL DISHWASHING LIQUID ANTIBACTÉRIEN LIQUIDE VAISSELLE | ANTIBACTERIANA LOUÇAS LÍQUIDO',
        },
        {
          la_name: 'CLM-001378.IN',
          la_statement: '99.9% BACTERIA PROTECTION',
        },
        {
          la_name: 'CLM-001384.IN',
          la_statement: 'I exist with the project',
        },
        {
          la_name: 'CLM-001385.IN',
          la_statement: 'Update Claims/LA exist with Product',
        },
        {
          la_name: 'CLM-001399.IN',
          la_statement: 'Sample Statement 1',
        },
        {
          la_name: 'CLM-001401.IN',
          la_statement: 'Test4',
        },
        {
          la_name: 'CLM-001403.IN',
          la_statement: 'ಪರೀಕ್ಷಾ ಹೇಳಿಕೆ 1',
        },
        {
          la_name: 'CLM-001386.IN',
          la_statement: 'Update Claims/LA exist with Surf Excel Product',
        },
        {
          la_name: 'CLM-001387.IN',
          la_statement: 'Update Claims/LA exist with Product',
        },
        {
          la_name: 'CLM-001383.IN',
          la_statement: 'I exist with the project',
        },
        {
          la_name: 'CLM-001388.IN',
          la_statement: 'I am new to this project',
        },
        {
          la_name: 'CLM-001394.IN',
          la_statement: 'ടെസ്റ്റ് സൃഷ്ടിക്കുന്നതിനുള്ള ഡമ്മി പ്രസ്താവന',
        },
        {
          la_name: 'CLM-001400.IN',
          la_statement: 'Sample Statement',
        },
        {
          la_name: 'CLM-001402.IN',
          la_statement: 'ಪರೀಕ್ಷಾ ಹೇಳಿಕೆ 2.',
        },
        {
          la_name: 'CLM-001409.IN',
          la_statement: 'Claim 3',
        },
        {
          la_name: 'CLM-001411.IN',
          la_statement: 'Claim 2',
        },
        {
          la_name: 'CLM-001412.IN',
          la_statement:
            'This is a claim This is a claim This is a claim This is a claim This is a claim This is a claim This is a claim This is a claim This is a claim This is a claim This is a claim',
        },
        {
          la_name: 'CLM-001413.IN',
          la_statement: 'Sample 2 in Kannada',
        },
        {
          la_name: 'CLM-001414.IN',
          la_statement: 'Sample 1 in Kannada',
        },
        {
          la_name: 'CLM-001417.IN',
          la_statement: 'SAVE WATER  ENERGY  TIME',
        },
        {
          la_name: 'CLM-001416.IN',
          la_statement: 'FABULOUS CLEAN  BEST EVER FRAGRANCE',
        },
        {
          la_name: 'CLM-001422.IN',
          la_statement: 'NEW Surf MAGNIFI-SCENT WASH',
        },
        {
          la_name: 'CLM-001423.IN',
          la_statement: 'FLIRTY FLORALS',
        },
        {
          la_name: 'CLM-001419.IN',
          la_statement: 'SASSY SWIRL',
        },
        {
          la_name: 'CLM-001418.IN',
          la_statement: 'ALL IN JUST 15 MINUTES',
        },
        {
          la_name: 'CLM-001410.IN',
          la_statement: 'Claim 4',
        },
        {
          la_name: 'CLM-001415.IN',
          la_statement: 'Sample 3 in Kannada',
        },
        {
          la_name: 'CLM-001424.IN',
          la_statement: 'GOLDEN BLISS',
        },
        {
          la_name: 'CLM-001421.IN',
          la_statement: 'Designed for SHORT CYCLES Even in 15 Minutes',
        },
        {
          la_name: 'CLM-001231.IN',
          la_statement: 'Vim',
        },
        {
          la_name: 'CLM-001228.IN',
          la_statement: '₹ 10/: WEEKLY PACK',
        },
        {
          la_name: 'CLM-001233.IN',
          la_statement: 'POWER OF 100 LEMONS',
        },
        {
          la_name: 'CLM-001229.IN',
          la_statement: 'POWER OF 108 LEMONS',
        },
        {
          la_name: 'CLM-001232.IN',
          la_statement: 'Concentrated Cal',
        },
        {
          la_name: 'CLM-001230.IN',
          la_statement: '₹ 20/-',
        },
        {
          la_name: 'CLM-001152.IN',
          la_statement: 'Super Soak Technology FOR SUPER STAIN REMOVAL',
        },
        {
          la_name: 'CLM-001293.IN',
          la_statement: 'Machine and Colour care',
        },
        {
          la_name: 'CLM-001407.IN',
          la_statement: 'Test2',
        },
        {
          la_name: 'CLM-001404.IN',
          la_statement: 'Test5',
        },
        {
          la_name: 'CLM-001408.IN',
          la_statement:
            'This is a test claim This is a test claim This is a test claim This is a test claim This is a test claim This is a test claim This is a test claim This is a test',
        },
        {
          la_name: 'CLM-001406.IN',
          la_statement: 'Test3',
        },
        {
          la_name: 'CLM-001201.IN',
          la_statement: 'Clean  Fresh Scent',
        },
        {
          la_name: 'CLM-000912.IN',
          la_statement:
            'New all® fresh & sensitive™ has a clean  fresh hypoallergenic scent  so its gentle on skin  but tough on stains. Now you can have it all.',
        },
        {
          la_name: 'CLM-000915.IN',
          la_statement: 'Faster Stain Removal',
        },
        {
          la_name: 'CLM-001208.IN',
          la_statement: 'Testing Save Veeva API',
        },
        {
          la_name: 'CLM-001234.IN',
          la_statement: 'Vim Liquid',
        },
        {
          la_name: 'CLM-001260.IN',
          la_statement: 'Bright like new',
        },
        {
          la_name: 'CLM-001405.IN',
          la_statement: 'Test1',
        },
        {
          la_name: 'CLM-004785.IN',
          la_statement: 'Surf Surf surfecel gdm',
        },
      ],
      related_products: [
        'Brilhante Washing Powder Brilhante Limpeza Total Pó',
        'Sunlight Plus Clean & Care',
        'Omo Concentrated Washing Capsules Test',
        'TRESemme Conditioner smooth TRESemmé Rich Moisture Conditioner',
        'Surf Excel Matic Std Liquid Test',
        "Ben & Jerry's Ice Cream Pint Test",
        'Surf Excel Washing Powder Surf Excel Easy Wash detergent powder',
        'TRESemme Shampoo TRESemme Rich Moisture Shampoo order',
        'TRESemme Shampoo TRESemmé Rich Moisture Shampoo',
        'All Concentrated Washing Liquid Fresh & Sensitive',
      ],
      related_projects: ['SPARCi (EEOC) project 1'],
      'substantiation__cr.description__v': 'Beauty Products',
      'substantiation__cr.name__v': 'SUB-000005',
    },
  ],
};

@Injectable({
  providedIn: 'root',
})
export class SubstantiationPopupService {
  constructor(private http: HttpClient) {}
  getSearchSubstantiation(data): Observable<any> {
    //return of(MOCK_JSON_WITHOUTGEO);
    // return of(MOCK_JSON_WITHGEO);
    const url = Const.connectionUrl + '/api/substantiation_search';
    return this.http.post(url, data);
  }

  getDocFrontpage(data): Observable<any> {
    //return of(MOCK_JSON_WITHOUTGEO);
    // return of(MOCK_JSON_WITHGEO);
    const url = Const.connectionUrl + '/api/get-doc-fpage';
    return this.http.post(url, data);
  }

  substantiationSearchSeeMore(data): Observable<any> {
    //return of(MOCK_JSON_WITHOUTGEO);
    // return of(MOCK_JSON_WITHGEO);
    const url = Const.connectionUrl + '/api/substantiation_search_see_more';
    return this.http.post(url, data);
  }

  checkAssetExist(data): Observable<any> {
    const url = Const.connectionUrl + '/api/check_asset_exist';
    return this.http.post(url, data);
  }

  getDropdownOptions(data): Observable<any> {
    //return of(MOCK_JSON_WITHOUTGEO);
    //return of(this.mockdata);
    const url = Const.connectionUrl + '/api/get_subtype_country_label';
    return this.http.post(url, data);
  }

  createSubstantiation(data): Observable<any> {
    //return of(MOCK_JSON_WITHOUTGEO);
    //return of(this.mockdata);
    const url = Const.connectionUrl + '/api/create_substantiation';
    return this.http.post(url, data);
  }

  recentlyAddedSubstantiation(data): Observable<any> {
    //return of(MOCK_JSON_WITHOUTGEO);
    //return of(this.mockdata);
    const url = Const.connectionUrl + '/api/recently_added_substantiations';
    return this.http.post(url, data);
  }

  saveRecentlyUsedSubstantiation(data): Observable<any> {
    const url = Const.connectionUrl + '/api/save_recently_used_substantiation';
    return this.http.post(url, data);
  }
}
